export default {
	verbose_name: {
		en: 'campaign',
		ge: 'კამპანია',
		de: 'Kampagne',
		ru: 'Кампания',
		cn: '活动',
		pt: 'campanha'
	},
	step02_welcome_message: {
		en: 'Please, select your campaign type',
		ge: 'გთხოვთ, აირჩიოთ თქვენი კამპანიის ტიპი',
		de: 'Bitte wählen Sie Ihren Kampagnentyp',
		ru: 'Пожалуйста, выберите тип кампании',
		cn: '请选择您的活动类型',
		pt: 'Por favor, selecione o tipo de sua campanha'
	},
	step02_goal: {
		en: 'goal',
		ge: 'მიზანი',
		de: 'Ziel',
		ru: 'цель',
		cn: '目标',
		pt: 'objetivo'
	},
	model_and_goal_error: {
		en: 'Please check model and goal fields',
		ge: 'გთხოვთ შეამოწმოთ მოდელის და მიზნის ველები',
		de: 'Bitte überprüfen Sie die Felder Modell und Ziel',
		ru: 'Пожалуйста, проверьте поля выбора модели и ввода цели',
		cn: '请检查模式和目标字段',
		pt: 'Por favor, verifique os campos de modelo e objetivo'
	},
	payment_model_label: {
		en: 'Campaign type',
		ge: 'კამპანიის ტიპი',
		de: 'Kampagnentyp',
		ru: 'Тип кампании',
		cn: '活动类型是',
		pt: 'Tipo de campanha'
	},
	model_choose_string01: {
		en: 'Campaign type is',
		ge: 'კამპანიის ტიპი არის',
		de: 'Der Kampagnentyp ist',
		ru: 'Тип кампании',
		cn: '活动类型是',
		pt: 'O tipo de campanha é'
	},
	model_choose_string02__ad_plays: {
		en: 'Goal is to reach',
		ge: 'მიზანი მიღწევადია',
		de: 'Das Ziel ist zu erreichen',
		ru: 'Цель достичь',
		cn: '目标是达到',
		pt: 'O objetivo é alcançar'
	},
	model_choose_string02__cpm: {
		en: 'Goal is to reach',
		ge: 'მიზანი მიღწევადია',
		de: 'Das Ziel ist es, die Zielgruppe zu erreichen',
		ru: 'Цель достичь аудитории',
		cn: '目标是达到',
		pt: 'O objetivo é alcançar'
	},
	model_choose_string02__cpv: {
		en: 'Goal is to reach',
		ge: 'მიზანი მიღწევადია',
		de: 'Das Ziel ist zu erreichen',
		ru: 'Цель достичь',
		cn: '目标是达到',
		pt: 'O objetivo é alcançar'
	},
	model_choose_string03__ad_plays: {
		en: 'shows',
		ge: 'ჩვენება',
		de: 'Shows',
		ru: 'показов',
		cn: '播放',
		pt: 'exibições'
	},
	model_choose_string03__cpm: {
		en: 'impressions',
		ge: 'შთაბეჭდილებები',
		de: 'Impressionen',
		ru: 'аудитория',
		cn: '展示',
		pt: 'impressões'
	},
	model_choose_string03__cpv: {
		en: 'guaranteed views',
		ge: 'გარანტირებული ნახვები',
		de: 'garantierte Aufrufe',
		ru: 'гарантированных просмотров',
		cn: '保证观看',
		pt: 'visualizações garantidas'
	},
	audience_label: {
		en: 'audience',
		ge: 'აუდიტორია',
		de: 'Zielgruppe',
		ru: 'аудитория',
		cn: '受众',
		pt: 'público'
	},
	audience_hint: {
		en: 'This option allows you to&nbsp;filter the broadcast points by&nbsp;interests or&nbsp;other historical audience data. For example, select screens with an&nbsp;audience interested in&nbsp;face creams.',
		ge: 'ეს პარამეტრი საშუალებას გაძლევთ&nbsp;გაფილტროთ სამაუწყებლო პუნქტები&nbsp;ინტერესების ან&nbsp;სხვა ისტორიული აუდიტორიის მონაცემების მიხედვით. მაგალითად, აირჩიეთ ეკრანები&nbsp;აუდიტორიით დაინტერესებული&nbsp;სახის კრემებით.',
		de: 'Diese Option ermöglicht es Ihnen, die Übertragungspunkte nach Interessen oder anderen historischen Zielgruppendaten zu filtern. Beispielsweise können Sie Bildschirme mit einer Zielgruppe auswählen, die an Gesichtscremes interessiert ist.',
		ru: 'Этот параметр позволяет фильтровать точки вещания по интересам или другим историческим данным об аудитории. Например, отобрать экраны с аудиторией, интересующейся кремами для лица.',
		cn: '通过此选项，您可以按照兴趣或其他历史受众数据筛选播放点。例如，选择对面霜感兴趣的受众附近的屏幕。',
		pt: 'Esta opção permite filtrar os pontos de exibição por interesses ou outros dados históricos do público. Por exemplo, selecione telas com um público interessado em cremes faciais.'
	},
	platform_label: {
		en: 'network',
		ge: 'ქსელი',
		de: 'Netzwerk',
		ru: 'рекламная сеть',
		cn: '网络',
		pt: 'rede'
	},
	all_platforms_label: {
		en: 'All networks',
		ge: 'ყველა ქსელი',
		de: 'Alle Netzwerke',
		ru: 'Все сети',
		cn: 'All networks',
		pt: 'Todas as redes'
	},
	platform_hint: {
		en: 'Select a network for the playback of the Сampaign',
		ge: 'აირჩიეთ ქსელი კამპანიის გასაშვებად',
		de: 'Wählen Sie ein Netzwerk für die Wiedergabe der Kampagne',
		ru: 'Выберите рекламную сеть для проигрывания Кампании',
		cn: '选择播放活动所使用的网络 ',
		pt: 'Selecione uma rede para a exibição da campanha'
	},
	selected_platforms: {
		en: 'Selected <b>{num}</b> networks',
		ge: 'არჩეული <b>{num}</b> ქსელები',
		de: 'Ausgewählte <b>{num}</b> Netzwerke',
		ru: 'Выбрано <b>{num}</b> сетей',
		cn: 'Selected <b>{num}</b> networks',
		pt: 'Selecionadas <b>{num}</b> redes'
	},
	reset_platforms_selection_confirmation_text: {
		en: 'Clear selected and select all networks?',
		ge: 'გასუფთავდეს არჩეული და შეარჩიო ყველა ქსელი?',
		de: 'Auswahl löschen und alle Netzwerke auswählen?',
		ru: 'Очистить выбранные опции и выбрать все сети?',
		cn: 'Clear selected and select all networks?',
		pt: 'Limpar seleção e selecionar todas as redes?'
	},
	age_label: {
		en: 'age',
		ge: 'ასაკი',
		de: 'Alter',
		ru: 'возраст',
		cn: '年龄',
		pt: 'idade'
	},
	gender_label: {
		en: 'gender',
		ge: 'სქესი',
		de: 'Geschlecht',
		ru: 'пол',
		cn: '性别',
		pt: 'gênero'
	},
	male: {
		en: 'Male',
		ge: 'მამაკაცი',
		de: 'Männlich',
		ru: 'Муж.',
		cn: '男性',
		pt: 'Masculino'
	},
	m70: {
		en: '70% M',
		ge: '70% კ',
		de: '70% M',
		ru: '70% М',
		cn: '70% 男性',
		pt: '70% M'
	},
	female: {
		en: 'Female',
		ge: 'ქალი',
		de: 'Weiblich',
		ru: 'Жен.',
		cn: '女性',
		pt: 'Feminino'
	},
	f70: {
		en: '70% F',
		ge: '70% ქ',
		de: '70% F',
		ru: '70% Ж',
		cn: '70% 女性',
		pt: '70% F'
	},
	interests: {
		en: 'interests',
		ge: 'ინტერესები',
		de: 'Interessen',
		ru: 'интересы',
		cn: '兴趣',
		pt: 'interesses'
	},
	feedback: {
		en: 'feedback',
		ge: 'უკუკავშირი',
		de: 'Rückmeldung',
		ru: 'описание',
		cn: '反馈',
		pt: 'feedback'
	},
	int_and_act_label: {
		en: 'Interests & Activities',
		ge: 'ინტერესები და აქტივობები',
		de: 'Interessen & Aktivitäten',
		ru: 'Интересы и активность',
		cn: '兴趣和活动',
		pt: 'Interesses e Atividades'
	},
	life_stage_label: {
		en: 'life stage',
		ge: 'სიცოცხლის ეტაპი',
		de: 'Lebensphase',
		ru: 'уровень жизни',
		cn: '生命阶段',
		pt: 'estágio de vida'
	},
	intent_label: {
		en: 'intent',
		ge: 'მიზანი',
		de: 'Absicht',
		ru: 'вовлечение',
		cn: '意向',
		pt: 'intenção'
	},
	environment_label: {
		en: 'environment',
		ge: 'გარემო',
		de: 'Umgebung',
		ru: 'окружение',
		cn: '环境',
		pt: 'ambiente'
	},
	environment_hint: {
		en: 'This option allows you to&nbsp;filter the broadcast points by&nbsp;the environment. For example, select the screens in&nbsp;front of&nbsp;the entrance or&nbsp;in&nbsp;the payment area.',
		ge: 'ეს პარამეტრი საშუალებას გაძლევთ &nbsp;გაფილტროთ სამაუწყებლო წერტილები&nbsp;გარემოს მიხედვით. მაგალითად, აირჩიეთ ეკრანები&nbsp;შესასვლელის წინ&nbsp; ან&nbsp; ში&nbsp;გადახდის ზონაში.',
		de: 'Diese Option ermöglicht es Ihnen, Übertragungspunkte nach der Umgebung zu filtern. Beispielsweise können Sie Bildschirme vor dem Eingang oder im Zahlungsbereich auswählen.',
		ru: 'Эта опция позволяет отфильтровать точки вещания по окружению. Например, выбрать экраны только у входа или у касс.',
		cn: '通过此选项，您可以按照环境筛选播放点。例如，选择入口处或付款处的屏幕。',
		pt: 'Esta opção permite filtrar os pontos de exibição pelo ambiente. Por exemplo, selecione as telas em frente à entrada ou na área de pagamento.'
	},
	poi_label: {
		en: 'POI',
		ge: 'ლოკაცია',
		de: 'POI',
		ru: 'POI',
		cn: 'POI',
		pt: 'Ponto de Interesse'
	},
	poi_hint: {
		en: 'This option allows you to&nbsp;filter broadcast points by&nbsp;the environment. For example, select screens within 100 meters of a bank.',
		ge: 'ეს პარამეტრი საშუალებას გაძლევთ&nbsp;გაფილტროთ სამაუწყებლო წერტილები&nbsp;გარემოს მიხედვით. მაგალითად, აირჩიეთ ეკრანები ბანკიდან 100 მეტრში.',
		de: 'Diese Option ermöglicht es Ihnen, Übertragungspunkte nach der Umgebung zu filtern. Beispielsweise können Sie Bildschirme innerhalb von 100 Metern um eine Bank auswählen.',
		ru: 'Эта опция позволяет отфильтровать точки вещания по окружению. Например, выбрать экраны в радиусе 100 метров от банка',
		cn: 'This option allows you to&nbsp;filter broadcast points by&nbsp;the environment. For example, select screens within 100 meters of a bank.',
		pt: 'Esta opção permite filtrar os pontos de exibição pelo ambiente. Por exemplo, selecione telas a 100 metros de um banco.'
	},
	select_pois: {
		en: 'Select POIs',
		ge: 'აირჩიეთ ლოკაცია',
		de: 'POIs auswählen',
		ru: 'Выберите POI',
		cn: 'Select POIs',
		pt: 'Selecionar POIs'
	},
	city_label: {
		en: 'city',
		ge: 'ქალაქი',
		de: 'Stadt',
		ru: 'город',
		cn: /* TODO: to be translated */ 'city',
		pt: 'Cidade'
	},
	resolution_label: {
		en: 'resolution',
		ge: 'რეზოლუცია',
		de: 'Auflösung',
		ru: 'разрешение',
		cn: '分辨率',
		pt: 'resolução'
	},
	orientation_label: {
		en: 'orientation',
		ge: 'ორიენტაცია',
		de: 'Ausrichtung',
		ru: 'ориентация',
		cn: '方向',
		pt: 'orientação'
	},
	type_label: {
		en: 'type',
		ge: 'ტიპი',
		de: 'Typ',
		ru: 'тип',
		cn: '类型',
		pt: 'tipo'
	},
	week_days_label: {
		en: 'week days',
		ge: 'კვირის დღეები',
		de: 'Wochentage',
		ru: 'дни недели',
		cn: '周几',
		pt: 'dias da semana'
	},
	week_rule: {
		en: 'week rule',
		ge: 'კვირის წესი',
		de: 'Wochenregel',
		ru: 'правило на неделю',
		cn: '周规则',
		pt: 'regra semanal'
	},
	payment_model: {
		en: 'payment model',
		ge: 'გადახდის მოდელი',
		de: 'Zahlungsmodell',
		ru: 'модель оплаты',
		cn: '付款方式',
		pt: 'modelo de pagamento'
	},
	mon: {
		en: 'mon',
		ge: 'ორშ',
		de: 'Mo',
		ru: 'пн',
		cn: '周一',
		pt: 'seg'
	},
	tue: {
		en: 'tue',
		ge: 'სამშ',
		de: 'Di',
		ru: 'вт',
		cn: '周二',
		pt: 'ter'
	},
	wed: {
		en: 'wed',
		ge: 'ოთხშ',
		de: 'Mi',
		ru: 'ср',
		cn: '周三',
		pt: 'qua'
	},
	thu: {
		en: 'thu',
		ge: 'ხუთ',
		de: 'Do',
		ru: 'чт',
		cn: '周四',
		pt: 'qui'
	},
	fri: {
		en: 'fri',
		ge: 'პარ',
		de: 'Fr',
		ru: 'пт',
		cn: '周五',
		pt: 'sex'
	},
	sat: {
		en: 'sat',
		ge: 'შაბ',
		de: 'Sa',
		ru: 'сб',
		cn: '周六',
		pt: 'sáb'
	},
	sun: {
		en: 'sun',
		ge: 'კვ',
		de: 'So',
		ru: 'вс',
		cn: '周日',
		pt: 'dom'
	},
	radius: {
		en: 'radius',
		ge: 'რადიუსი',
		de: 'Radius',
		ru: 'радиус',
		cn: '半径',
		pt: 'raio'
	},
	distance: {
		en: 'distance',
		ge: 'დისტანცია',
		de: 'Entfernung',
		ru: 'дистанция',
		cn: 'distance',
		pt: 'distância'
	},
	address: {
		en: 'address',
		ge: 'მისამართი',
		de: 'Adresse',
		ru: 'адрес',
		cn: '地址',
		pt: 'endereço'
	},
	address_placeholder: {
		en: 'Enter address...',
		ge: 'შეიყვანეთ მისამართი...',
		de: 'Adresse eingeben...',
		ru: 'Введите адрес...',
		cn: '输入地址...',
		pt: 'Digite o endereço...'
	},
	radius_units_km: {
		en: 'km',
		ge: 'კმ',
		de: 'km',
		ru: 'км',
		cn: '千米',
		pt: 'km'
	},
	radius_units_m: {
		en: 'm',
		ge: 'მ',
		de: 'm',
		ru: 'м',
		cn: 'm',
		pt: 'm'
	},
	broadcasting_points: {
		en: 'broadcasting points',
		ge: 'მაუწყებლობის წერტილები',
		de: 'Übertragungspunkte',
		ru: 'точки вещания',
		cn: '播放点',
		pt: 'pontos de exibição'
	},
	budget_n_schedule_title: {
		en: 'set budget and schedule',
		ge: 'დაადგინეთ ბიუჯეტი და გრაფიკი',
		de: 'Budget und Zeitplan festlegen',
		ru: 'бюджет и расписание',
		cn: '设定预算和时间表',
		pt: 'defina o orçamento e o cronograma'
	},
	time_period: {
		en: 'time period',
		ge: 'დროის პერიოდი',
		de: 'Zeitraum',
		ru: 'период времени',
		cn: '时间段',
		pt: 'período de tempo'
	},
	time_range: {
		en: 'time range',
		ge: 'დროის დიაპაზონი',
		de: 'Zeitraum',
		ru: 'временной интервал',
		cn: '时间范围',
		pt: 'intervalo de tempo'
	},
	age_range: {
		en: 'age range',
		ge: 'ასაკის დიაპაზონი',
		de: 'Altersbereich',
		ru: 'возрастной интервал',
		cn: '年龄范围',
		pt: 'faixa etária'
	},
	message_duration: {
		en: 'message duration',
		ge: 'გზავნილის ხანგრძლივობა',
		de: 'Nachrichtendauer',
		ru: 'Длительность',
		cn: '消息时长',
		pt: 'duração da mensagem'
	},
	frequency_limit: {
		en: 'frequency limit',
		ge: 'სიხშირის ლიმიტი',
		de: 'Frequenzlimit',
		ru: 'частота показов',
		cn: '频率限制',
		pt: 'limite de frequência'
	},
	per_hour: {
		en: 'per&nbsp;hour',
		ge: 'ერთ&nbsp; საათში',
		de: 'pro&nbsp;Stunde',
		ru: 'за&nbsp;час',
		cn: '每小时',
		pt: 'por hora'
	},
	per_device: {
		en: 'per&nbsp;device',
		ge: 'თითო&nbsp; მოწყობილობაში',
		de: 'pro&nbsp;Gerät',
		ru: 'на&nbsp;одном устройстве',
		cn: '每台设备',
		pt: 'por dispositivo'
	},
	per_hour_per_device: {
		en: 'per&nbsp;hour per&nbsp;device',
		ge: 'ერთ&nbsp;საათში ერთ&nbsp; მოწყობილობაზე',
		de: 'pro&nbsp;Stunde pro&nbsp;Gerät',
		ru: 'за&nbsp;час на&nbsp;одном устройстве',
		cn: '每台设备每小时',
		pt: 'por hora por dispositivo'
	},
	ad_flight: {
		en: 'ad flight',
		ge: 'რეკლამის გაშვება',
		de: 'Anzeigenschaltung',
		ru: 'Протяженность',
		cn: '广告投放',
		pt: 'exibição de anúncio'
	},
	ad_flight_days: {
		en: 'Days',
		ge: 'დღეები',
		de: 'Tage',
		ru: 'Дней',
		cn: 'Days',
		pt: 'Dias'
	},
	for_hour: {
		en: 'In {value} hour',
		ge: '{value} საათი',
		de: 'In {value} Stunde',
		ru: 'За {value} час',
		cn: 'In {value} hour',
		pt: 'Em {value} hora'
	},
	for_minutes: {
		en: 'In {value} minutes',
		ge: '{value} წუთები',
		de: 'In {value} Minuten',
		ru: 'За {value} минут',
		cn: 'In {value} minutes',
		pt: 'Em {value} minutos'
	},
	ad_flight_hint: {
		en: 'Campaign duration, a month by default',
		ge: 'კამპანიის ხანგრძლივობა, ნაგულისხმევად ერთი თვე',
		de: 'Kampagnendauer, standardmäßig ein Monat',
		ru: 'Длительность кампании, по умолчанию месяц',
		cn: '活动时长',
		pt: 'Duração da campanha, padrão de um mês'
	},
	target_type: {
		en: 'target type',
		ge: 'სამიზნე ტიპი',
		de: 'Zieltyp',
		ru: 'тип цели',
		cn: '目标类型',
		pt: 'tipo de alvo'
	},
	target_type_hint: {
		en: '<div class=\'payment_model-hint\' >\n\t\t<p>In&nbsp;the first step when creating advertising it&nbsp;is&nbsp;necessary to&nbsp;choose the target. The goal should match what you want to&nbsp;achieve:</p>\n\t\t<ul>\n\t\t\t<li><b>Shows (Ad&nbsp;Plays)</b>. You want to&nbsp;achieve the number of&nbsp;ad&nbsp;plays by&nbsp;the broadcast without audience information. The best type for broadcast points without cameras or&nbsp;audience data or&nbsp;for audio marketing.</li>\n\t\t\t<li><b>Impressions (CPM)</b>. You want to&nbsp;reach your target audience. Broadcasting goes in&nbsp;cycles based on&nbsp;the audience historical data. Suitable for large screens and other massive installations or&nbsp;for audio marketing.</li>\n\t\t\t<li><b>Views (CPV)</b>. You want to&nbsp;achieve the number of&nbsp;guaranteed views of&nbsp;the target audience. Suitable for broadcast points with cameras.</li>\n\t\t</ul>\n\t</div>',
		ge: '<div class=\'payment_model-hint\' >\n\t\t<p>რეკლამის შექმნისას&nbsp;პირველ ეტაპზე&nbsp;აუცილებელია&nbsp;სამიზნის შერჩევა. მიზანი უნდა შეესაბამებოდეს იმას, რისი მიღწევაც გსურთ:</p>\n\n\t\t<ul>\n\t\t\t<li><b>შოუები (რეკლამა&nbsp;თამაშები)</b>. გსურთ&nbsp;მიაღწიოთ&nbsp;რეკლამის&nbsp;თამაშების რაოდენობას&nbsp;მაუწყებლობის მიერ აუდიტორიის ინფორმაციის გარეშე. საუკეთესო ტიპი სამაუწყებლო წერტილებისთვის კამერების ან&nbsp;აუდიტორიის მონაცემების ან&nbsp;აუდიო მარკეტინგისთვის.</li>\n\t\t\t<li><b>ჩვენებები (CPM)</b>. გსურთ&nbsp;მიაღწიოთ თქვენს სამიზნე აუდიტორიას. მაუწყებლობა მიმდინარეობს&nbsp;ციკლებში, ეფუძნება&nbsp;მაყურებლის ისტორიულ მონაცემებს. შესაფერისია დიდი ეკრანებისთვის და სხვა მასიური ინსტალაციებისთვის ან აუდიო მარკეტინგისთვის.</li>\n\n\t\t<li><b>ნახვები (CPV)</b>. გსურთ&nbsp;მიაღწიოთ&nbsp;სამიზნე აუდიტორიის&nbsp;გარანტირებული ნახვების რაოდენობას. ვარგისია კამერებით გადაცემის წერტილებისთვის.</li>\n\t\t</ul>\n\t</div>',
		de: '<div class=\'payment_model-hint\' >\n\t\t<p>Im&nbsp;ersten Schritt bei der Erstellung von Werbung muss das Ziel ausgewählt werden. Das Ziel sollte dem entsprechen, was Sie erreichen möchten:</p>\n\t\t<ul>\n\t\t\t<li><b>Shows (Ad&nbsp;Plays)</b>. Sie möchten die Anzahl der Werbeeinblendungen durch die Übertragung ohne Zuschauerinformationen erreichen. Am besten geeignet für Übertragungspunkte ohne Kameras oder Zuschauerdaten oder für Audiomarketing.</li>\n\t\t\t<li><b>Impressions (CPM)</b>. Sie möchten Ihre Zielgruppe erreichen. Die Übertragung erfolgt in Zyklen basierend auf den historischen Daten der Zielgruppe. Geeignet für große Bildschirme und andere massive Installationen oder für Audiomarketing.</li>\n\t\t\t<li><b>Views (CPV)</b>. Sie möchten die Anzahl der garantierten Aufrufe der Zielgruppe erreichen. Geeignet für Übertragungspunkte mit Kameras.</li>\n\t\t</ul>\n\t</div>',
		ru: '<div class=\'payment_model-hint\' >\n\t\t<p>При создании рекламы надо выбрать цель. Цель должна соответствовать тому, чего вы хотите добиться:</p>\n\t\t<ul>\n\t\t\t<li><b>Показы (Ad Plays)</b>. Вы хотите добиться установленного вами количества выходов кампании в эфир путём трансляции без учета аудитории. Подходит для точек вещания без камер или данных об аудитории или для аудиомаркетинга.</li>\n\t\t\t<li><b>Охват (СPM)</b>. Вы хотите добиться установленного вами охвата вашей целевой аудитории. Трансляция происходит в цикле с учётом аудитории на основе исторических данных. Подходит для больших экранов и прочих охватных инсталляций или для аудиомаркетинга.</li>\n\t\t\t<li><b>Просмотры (СPV)</b>. Вы хотите добиться установленного вами количества гарантированных просмотров целевой аудитории. Подходит для точек вещания с камерами.</li>\n\t\t</ul>\n\t</div>',
		cn: '<div class=\'payment_model-hint\' >\n\t\t<p>创建广告时，首先需要选择目标。目标要符合您的实际需求：</p>\n\t\t<ul>\n\t\t\t<li><b>播放（广告播放）</b>。您希望在没有受众信息的播放点达成一定次数的广告播放。此类型适用于没有摄像头或受众数据的播放点，以及音频营销。</li>\n\t\t\t<li><b>展示（每千次展示费用）</b>。您希望展示给特定目标受众。根据受众历史数据循环播放。此类型适用于大屏幕或其他大型装置，以及音频营销。</li>\n\t\t\t<li><b>观看（每次观看费用）</b>。您希望确保目标受众一定次数的观看。此类型适用于带有摄像头的播放点。</li>\n\t\t</ul>\n\t</div>',
		pt: '<div class="payment_model-hint">\n\t\t<p>No primeiro passo ao criar uma campanha publicitária, é necessário escolher o alvo. O objetivo deve corresponder ao que você deseja alcançar:</p>\n\t\t<ul>\n\t\t\t<li><b>Exibições (Reproduções de anúncio)</b>. Você deseja alcançar um número de reproduções do anúncio por meio da transmissão sem informações sobre o público. Este é o tipo ideal para pontos de exibição sem câmeras ou dados de audiência, ou para marketing de áudio.</li>\n\t\t\t<li><b>Impressões (CPM)</b>. Você deseja alcançar seu público-alvo. A transmissão ocorre em ciclos com base em dados históricos do público. Adequado para telas grandes e outras instalações de grande porte, ou para marketing de áudio.</li>\n\t\t\t<li><b>Visualizações (CPV)</b>. Você deseja alcançar um número garantido de visualizações pelo seu público-alvo. Adequado para pontos de exibição com câmeras.</li>\n\t\t</ul>\n\t</div>'
	},
	target_plays: {
		en: 'target plays',
		ge: 'სამიზნე ჩვენებები',
		de: 'Ziel-Wiedergaben',
		ru: 'цель по показам',
		cn: '目标播放',
		pt: 'reproduções-alvo'
	},
	target_ots: {
		en: 'target ots',
		ge: 'სამიზნე ამოცანები',
		de: 'Ziel-OTS',
		ru: 'цель по ots',
		cn: '目标视听机会',
		pt: 'OTS-alvo'
	},
	target_views: {
		en: 'target views',
		ge: 'სამიზნე ნახვები',
		de: 'Zielaufrufe',
		ru: 'цель по просмотрам',
		cn: '目标观看',
		pt: 'visualizações-alvo'
	},
	budget: {
		en: 'budget',
		ge: 'ბიუჯეტი',
		de: 'Budget',
		ru: 'бюджет',
		cn: '预算',
		pt: 'orçamento'
	},
	budget_type: {
		en: 'campaign budget',
		ge: 'ბიუჯეტი',
		de: 'Budget',
		ru: 'общий бюджет',
		cn: '预算',
		pt: 'orçamento'
	},
	budget_hint: {
		en: '<b>Your budget</b>. Set the spending limit at which the advertising campaign will stop.',
		ge: '<b>თქვენი ბიუჯეტი</b>. დააყენეთ ხარჯვის ლიმიტი, რომელზეც შეჩერდება სარეკლამო კამპანია.',
		de: '<b>Ihr Budget</b>. Legen Sie das Ausgabenlimit fest, bei dem die Werbekampagne gestoppt wird.',
		ru: '<b>Ваш бюджет</b>. Установите ограничение расхода. При достижении рекламная кампания остановится.',
		cn: '<b>您的预算</b>。设定费用上限，到达此上限时，广告活动即停止。',
		pt: '<b>Seu orçamento</b>. Defina o limite de gastos no qual a campanha publicitária será interrompida.'
	},
	daily_budget: {
		en: 'daily budget',
		ge: 'daily budget',  // TODO: translation needed
		de: 'daily budget',  // TODO: translation needed
		ru: 'бюджет на день',
		cn: 'daily budget',  // TODO: translation needed
		pt: 'daily budget'  // TODO: translation needed
	},
	max_bid: {
		en: 'max bid',
		ge: 'მაქსიმუმალური bid',
		de: 'Höchstgebot',
		ru: 'максимальная ставка',
		cn: '最高出价',
		pt: 'lance máximo'
	},
	max_bid_hint: {
		en: '<div class=\'maximum_bid-hint\'>\n\t\t\t\t<p><b>Maximum BID</b>. The highest price an&nbsp;advertiser is&nbsp;willing to&nbsp;pay for Ad&nbsp;Plays, audience (OTS) or&nbsp;views. Depending on&nbsp;the target.</p>\n\t\t\t\t<p>The auction goes at&nbsp;each point of&nbsp;broadcasting at&nbsp;the time of&nbsp;possible playback of&nbsp;the campaign.</p>\n\t\t\t</div>',
		ge: '<div class=\'maximum_bid-hint\'>\n\t\t\t\t<p><b>მაქსიმალური BID</b>. ყველა ფასი, რომელსაც რეკლამის განმთავსებელი მზად არის გადაიხადოს Ad&nbsp;Plays, აუდიტორია (OTS) ან&nbsp;ნახვები. დამოკიდებულია სამიზნეზე.</p>\n\t\t\t\t<p>აუქციონი მიმდინარეობს თითოეულ მაუწყებლო წერტილზე კამპანიის შესაძლო დაკვრის დროში.</p>\n\t\t\t</div>',
		de: '<div class=\'maximum_bid-hint\'>\n\t\t\t\t<p><b>Höchstgebot</b>. Der höchste Preis, den ein&nbsp;Werbetreibender bereit ist, für Ad&nbsp;Plays, Zielgruppe (OTS) oder&nbsp;Aufrufe zu&nbsp;zahlen. Abhängig vom&nbsp;Ziel.</p>\n\t\t\t\t<p>Die Auktion findet an&nbsp;jedem Übertragungspunkt zum&nbsp;Zeitpunkt der möglichen Wiedergabe der Kampagne statt.</p>\n\t\t\t</div>',
		ru: '<div class=\'maximum_bid-hint\'>\n\t\t\t\t<p><b>Максимальная ставка</b>. Это наивысшая цена, которую рекламодатель готов заплатить за воспроизведения, аудиторию (OTS) или просмотры. Зависит от выбранной цели.</p>\n\t\t\t\t<p>Аукцион проводится на каждой точке вещания в момент возможного воспроизведения кампании.</p>\n\t\t\t</div>',
		cn: '<div class=\'maximum_bid-hint\'>\n\t\t\t\t<p><b>最高出价</b>。广告客户愿意为广告播放、受众（OTS）或观看支付的最高价格，视目标而定。</p>\n\t\t\t\t<p>拍卖在每个播放点，在广告可能播放的时刻进行。</p>\n\t\t\t</div>',
		pt: '<div class="maximum_bid-hint">\n\t\t\t<p><b>Lance máximo</b>. O preço máximo que um anunciante está disposto a pagar por reproduções de anúncio, público (OTS) ou visualizações, dependendo do alvo.</p>\n\t\t\t<p>O leilão ocorre em cada ponto de exibição no momento da possível reprodução da campanha.</p>\n\t\t</div>'
	},
	budget_more_than_balance: {
		en: 'Campaign budget exceeds advertising agency budget',
		ge: 'კამპანიის ბიუჯეტი აღემატება სარეკლამო სააგენტოს ბიუჯეტს',
		de: 'Das Kampagnenbudget übersteigt das Budget der Werbeagentur',
		ru: 'Бюджет кампании превышает бюджет рекламного агенства',
		cn: 'Campaign budget exceeds advertising agency budget',
		pt: 'O orçamento da campanha excede o orçamento da agência de publicidade'
	},
	insufficient_balance_request_dsp_view: {
		en: 'Top up your balance before submitting your request',
		ge: 'შეავსეთ ბალანსი თქვენი მოთხოვნის გაგზავნამდე',
		de: 'Laden Sie Ihr Guthaben auf, bevor Sie Ihre Anfrage einreichen',
		ru: 'Пополните баланс перед отправкой запроса',
		cn: 'Top up your balance before submitting your request',
		pt: 'Recarregue seu saldo antes de enviar sua solicitação'
	},
	insufficient_balance_dsp_view: {
		en: 'To continue the campaign, top up your balance',
		ge: 'კამპანიის გასაგრძელებლად შეავსეთ ბალანსი',
		de: 'Um die Kampagne fortzusetzen, laden Sie Ihr Guthaben auf',
		ru: 'Для продолжения кампании пополните баланс',
		cn: 'To continue the campaign, top up your balance',
		pt: 'Para continuar a campanha, recarregue seu saldo'
	},
	insufficient_balance_ssp_view: {
		en: 'The DSP agency has a negative balance',
		ge: 'DSP სააგენტოს აქვს უარყოფითი ბალანსი',
		de: 'Das DSP-Agentur hat ein negatives Guthaben',
		ru: 'У DSP агентства отрицательный баланс',
		cn: 'The DSP agency has a negative balance',
		pt: 'A agência DSP tem saldo negativo'
	},
	sec: {
		en: 'sec',
		ge: 'წმ',
		de: 'Sek',
		ru: 'сек',
		cn: '秒',
		pt: 'seg'
	},
	seconds: {
		en: '0 seconds | 1 second | {n} seconds',
		ge: '0 წამი | 1 წამი | {n} წამი',
		de: '0 Sekunden | {n} Sekunde | {n} Sekunden',
		ru: '0 секунд | {n} cекунду | {n} секунды | {n} секунд',
		cn: '0 秒 | 1 秒 | {n} 秒',
		pt: '0 segundos | 1 segundo | {n} segundos'
	},
	seconds_won: {
		en: 'seconds | second | seconds',
		ge: 'წამები | წამი | წამები',
		de: 'Sekunden | Sekunde | Sekunden',
		ru: 'секунд | cекунду | секунды | секунд',
		cn: '秒 | 秒 | 秒',
		pt: 'segundos | segundo | segundos'
	},
	days: {
		en: '0 days | 1 day | {n} days',
		ge: '0 დღე | 1 დღე | {n} დღე',
		de: '0 Tage | 1 Tag | {n} Tage',
		ru: '0 дней | {n} день | {n} дня | {n} дней',
		cn: '0 天 | 1 天 | {n} 天',
		pt: '0 dias | 1 dia | {n} dias'
	},
	days_won: {
		en: 'days | day | days',
		ge: 'დღეები | დღე | დღეები',
		de: 'Tage | Tag | Tage',
		ru: 'дней | день | дня | дней',
		cn: '天 | 天 | 天',
		pt: 'dias | dia | dias'
	},
	model_phrase: {
		en: 'for a {seconds} creative',
		ge: '{seconds} შექმნაში',
		de: 'für ein {seconds} kreative',
		ru: 'при длительности креатива в {seconds}',
		cn: '持续时间为 {seconds} 秒的广告内容',
		pt: 'para um criativo de {seconds}'
	},
	budget_desc_spend_to: {
		en: 'You`ll spend up to <b>{budget_to_spend}</b> for this line order.',
		ge: 'თქვენ დახარჯავთ <b>{budget_to_spend}</b>-მდე ამ შეკვეთისთვის',
		de: 'Sie werden bis zu <b>{budget_to_spend}</b> für diese Bestellung ausgeben.',
		ru: 'Вы потратите до <b>{budget_to_spend}</b> на этот заказ.',
		cn: '此订单的最高费用为 <b>{budget_to_spend}</b>。',
		pt: 'Você gastará até <b>{budget_to_spend}</b> para este pedido.'
	},
	budget_desc_target_budget: {
		en: 'The estimated budget for your goal is <b>{target_budget}</b>',
		ge: 'თქვენი მიზნის სავარაუდო ბიუჯეტია  <b>{target_budget}</b>',
		de: 'Das geschätzte Budget für Ihr Ziel beträgt <b>{target_budget}</b>',
		ru: 'Предполагаемый бюджет для вашей цели &ndash; <b>{target_budget}</b>',
		cn: '要达成您的目标，预估费用为 <b>{target_budget}</b>',
		pt: 'O orçamento estimado para o seu objetivo é <b>{target_budget}</b>'
	},
	budget_desc_max_budget: {
		en: 'The current maximum estimated budget for this line order is <b>{budget_max_limit}</b>',
		ge: 'ამ ხაზის შეკვეთის მიმდინარე მაქსიმალური სავარაუდო ბიუჯეტი არის <b>{budget_max_limit}</b>',
		de: 'Das aktuelle maximale geschätzte Budget für diese Bestellung beträgt <b>{budget_max_limit}</b>',
		ru: 'Текущий максимальный ожидаемый бюджет на этот заказ &ndash; <b>{budget_max_limit}</b>',
		cn: '此订单当前最高预估费用为 <b>{budget_max_limit}</b>',
		pt: 'O orçamento máximo estimado atual para este pedido é <b>{budget_max_limit}</b>'
	},
	bid_desc: {
		en: 'The effective bid range is&nbsp;<b>{min_price}&nbsp;&mdash; {max_price}</b>.<br />Your max bid will be&nbsp;adjusted to&nbsp;your creative duration.',
		ge: 'ეფექტური შეთავაზების დიაპაზონი არის&nbsp;<b>{min_price}&nbsp;&mdash; {max_price}</b>.<br />თქვენი მაქსიმალური შეთავაზება &nbsp;მოერგება&nbsp;თქვენს შემოქმედების ხანგრძლივობას',
		de: 'Der effektive Gebotsbereich beträgt&nbsp;<b>{min_price}&nbsp;&mdash; {max_price}</b>.<br />Ihr Höchstgebot wird an&nbsp;die Dauer Ihres kreativen Inhalts angepasst.',
		ru: 'Эффективный диапазон ставок &mdash;&nbsp;<b>{min_price}&nbsp;&mdash; {max_price}</b>.<br />Максимальная ставка основана на длительности креатива',
		cn: '最有效的出价区间为 <b>{min_price} 至 {max_price}</b>。<br />您的最高出价会随广告内容时长调整。',
		pt: 'A faixa efetiva de lance é <b>{min_price} — {max_price}</b>.<br />Seu lance máximo será ajustado à duração do seu criativo.'
	},
	bid_desc_short: {
		en: 'The effective bid range is&nbsp;<b>{min_price}&nbsp;&mdash; {max_price}</b>.',
		ge: 'ეფექტური შეთავაზების დიაპაზონი არის&nbsp;<b>{min_price}&nbsp;&mdash; {max_price}</b>.',
		de: 'Der effektive Gebotsbereich beträgt&nbsp;<b>{min_price}&nbsp;&mdash; {max_price}</b>.',
		ru: 'Эффективный диапазон ставок &mdash;&nbsp;<b>{min_price}&nbsp;&mdash; {max_price}</b>.',
		cn: '最有效的出价区间为 <b>{min_price} 至 {max_price}</b>。',
		pt: 'A faixa efetiva de lance é <b>{min_price} — {max_price}</b>.'
	},
	schedule: {
		en: 'schedule',
		ge: 'განრიგი',
		de: 'Zeitplan',
		ru: 'расписание',
		cn: '时间表',
		pt: 'cronograma'
	},
	max_bid_changed: {
		en: 'Max bid changed from {old} to {new}',
		ge: 'მაქსიმალური შეთავაზება შეიცვალა {old}-დან {new}',
		de: 'Höchstgebot von {old} auf {new} geändert',
		ru: 'Максимальная ставка изменилась с {old} на {new}',
		cn: '最高出价从 {old} 更改为 {new}',
		pt: 'O lance máximo mudou de {old} para {new}'
	},
	campaign_name: {
		en: 'campaign name',
		ge: 'კამპანიის სახელი',
		de: 'Kampagnenname',
		ru: 'название кампании',
		cn: '活动名称',
		pt: 'nome da campanha'
	},
	campaign_name_placeholder: {
		en: 'enter campaign name',
		ge: 'შეიყვანეთ კამპანიის სახელ',
		de: 'Kampagnennamen eingeben',
		ru: 'введите название кампании',
		cn: '输入活动名称',
		pt: 'digite o nome da campanha'
	},
	content_category_label: {
		en: 'content category',
		ge: 'შინაარსის კატეგორია',
		de: 'Inhaltskategorie',
		ru: 'категория контента',
		cn: '内容类别',
		pt: 'categoria de conteúdo'
	},
	content_category_placeholder: {
		en: 'Choose category',
		ge: 'აირჩიე კატეგორია',
		de: 'Kategorie wählen',
		ru: 'выберите категорию',
		cn: '选择类别',
		pt: 'Escolha a categoria'
	},
	advertiser_label: {
		en: 'advertiser',
		ge: 'რეკლამის განმთავსებელი',
		de: 'Werbetreibender',
		ru: 'рекламодатель',
		cn: '广告客户',
		pt: 'anunciante'
	},
	advertiser_placeholder: {
		en: 'find and choose..',
		ge: 'იპოვე და აირჩიე..',
		de: 'finden und auswählen..',
		ru: 'поиск и выбор..',
		cn: '查找并选择..',
		pt: 'procure e escolha...'
	},
	select_placeholder: {
		en: 'find...',
		ge: 'იპოვე...',
		de: 'finden...',
		ru: 'найти...',
		cn: '查找...',
		pt: 'encontre...'
	},
	step01_title: {
		en: 'request',
		ge: 'მოთხოვნა',
		de: 'Anfrage',
		ru: 'запрос',
		cn: '请求',
		pt: 'solicitação'
	},
	step02_title: {
		en: 'product',
		ge: 'პროდუქტი',
		de: 'Produkt',
		ru: 'продукт',
		cn: '产品',
		pt: 'produto'
	},
	step03_title: {
		en: 'order',
		ge: 'შეკვეთა',
		de: 'Bestellung',
		ru: 'заказ',
		cn: '订单',
		pt: 'pedido'
	},
	step04_title: {
		en: 'creative',
		ge: 'შექმნა',
		de: 'Kreativ',
		ru: 'креатив',
		cn: '广告内容',
		pt: 'criativo'
	},
	next_btn_label: {
		en: 'next',
		ge: 'შემდეგი',
		de: 'weiter',
		ru: 'далее',
		cn: '下一步',
		pt: 'próximo'
	},
	back_btn_label: {
		en: 'back',
		ge: 'უკან',
		de: 'zurück',
		ru: 'назад',
		cn: '返回',
		pt: 'voltar'
	},
	close_btn_label: {
		en: 'close',
		ge: 'დახურვა',
		de: 'schließen',
		ru: 'закрыть',
		cn: '关闭',
		pt: 'fechar'
	},
	creative_text: {
		en: 'Creatives can be slightly cropped to accommodate suppliers’ screen specifications. We suggest to avoid positioning logos and text close to the edges. For best results, leave a 5% margin on each side.',
		ge: 'რეკლამის ზომები შეიძლება ოდნავ შემცირდეს მომწოდებლების ეკრანის სპეციფიკაციების დასაკმაყოფილებლად. ჩვენ გირჩევთ, მოერიდოთ ლოგოების და ტექსტის კიდეებთან ახლოს განთავსებას. საუკეთესო შედეგისთვის, დატოვეთ 5% ზღვარი თითოეულ მხარეს.',
		de: 'Kreative können leicht beschnitten werden, um den Spezifikationen der Bildschirme der Anbieter zu entsprechen. Wir empfehlen, Logos und Texte nicht zu nah an den Rändern zu platzieren. Für beste Ergebnisse lassen Sie einen Rand von 5% auf jeder Seite.',
		ru: 'Креативы могут быть слегка обрезаны по краям в соответствии со спецификациями экранов. Рекомендуется избегать размещения логотипов и текста близко к краям креатива. Для оптимального результата используйте отступ в 5% от размера формата.',
		cn: '广告内容可能会被稍稍裁切，以适应供应商的屏幕尺寸。我们建议不要将商标和文字放置在边缘处。为达到最佳效果，四边请各留出 5% 的空白。',
		pt: 'Os criativos podem ser levemente cortados para se adequar às especificações da tela dos fornecedores. Sugerimos evitar posicionar logotipos e textos próximos às bordas. Para melhores resultados, deixe uma margem de 5% em cada lado.'
	},
	creative_full_spec_btn_label: {
		en: 'See the complete creative specs',
		ge: 'იხილეთ სრული შექმნის სპეციფიკაციები',
		de: 'Sehen Sie die vollständigen kreativen Spezifikationen',
		ru: 'Посмотреть полную спецификацию для креативов',
		cn: '查看广告内容的完整属性',
		pt: 'Veja as especificações completas do criativo'
	},
	privacy_policies_line_01: {
		en: 'please review our',
		ge: 'გთხოვთ გადახედოთ ჩვენს',
		de: 'Bitte überprüfen Sie unsere',
		ru: 'Пожалуйста изучите наши',
		cn: '在提交之前',
		pt: 'por favor, revise nossas'
	},
	privacy_policies_line_02: {
		en: 'creative policies',
		ge: 'შექმნის პოლიტიკა',
		de: 'kreativen Richtlinien',
		ru: 'регулирующие документы',
		cn: '请查看我们的',
		pt: 'políticas de criativos'
	},
	privacy_policies_line_03: {
		en: 'before submitting',
		ge: 'გაგზავნამდე',
		de: 'vor dem Einreichen',
		ru: 'перед отправкой',
		cn: '广告内容政策',
		pt: 'antes de enviar'
	},
	place_order_btn_label: {
		en: 'place order',
		ge: 'განათავსეთ შეკვეთა',
		de: 'Bestellung aufgeben',
		ru: 'разместить запрос',
		cn: '提交订单',
		pt: 'fazer pedido'
	},
	save_as_draft_btn_label: {
		en: 'save as draft',
		ge: 'შენახვა როგორც მონახაზი',
		de: 'als Entwurf speichern',
		ru: 'сохранить как черновик',
		cn: '另存为草稿',
		pt: 'salvar como rascunho'
	},
	or: {
		en: 'or',
		ge: 'ან',
		de: 'oder',
		ru: 'или',
		cn: '或',
		pt: 'ou'
	},
	monitor: {
		en: 'screen',
		ge: 'ეკრანი',
		de: 'Bildschirm',
		ru: 'экран',
		cn: '屏幕',
		pt: 'tela'
	},
	other: {
		en: 'other',
		ge: 'სხვა',
		de: 'andere',
		ru: 'остальное',
		cn: '其他',
		pt: 'outro'
	},
	devices: {
		en: '0 devices | 1 device | {n} devices',
		ge: '0 მოწყობილობა | 1 მოწყობილობა | {n} მოწყობილობა',
		de: '0 Geräte | 1 Gerät | {n} Geräte',
		ru: '0 устройств | {n} устройство | {n} устройства | {n} устройств',
		cn: '0 台设备 | 1 台设备 | {n} 台设备',
		pt: '0 dispositivos | 1 dispositivo | {n} dispositivos'
	},
	upload_content_btn_label: {
		en: 'upload content',
		ge: 'ატვირთეთ შინაარსი',
		de: 'Inhalt hochladen',
		ru: 'загрузить контент',
		cn: '上传内容',
		pt: 'carregar conteúdo'
	},
	upload_doc_btn_label: {
		en: 'upload documents',
		ge: 'upload documents',
		de: 'upload documents',
		ru: 'загрузить документы',
		cn: 'upload documents',
		pt: 'carregar documentos'
	},
	choose_creative_btn_label: {
		en: 'choose',
		ge: 'არჩევა',
		de: 'wählen',
		ru: 'выбрать',
		cn: '选择',
		pt: 'escolher'
	},
	no_creatives_issue: {
		en: 'Request without any creatives added could be saved only as a draft',
		ge: 'შექმნილის დამატების მოთხოვნის გარეშე ის შეინახება მხოლოდ მონახაზად',
		de: 'Anfrage ohne hinzugefügte kreative Inhalte kann nur als Entwurf gespeichert werden',
		ru: 'Запрос без креативов может быть сохранён только как черновик',
		cn: '没有添加任何广告内容的请求只能另存为草稿',
		pt: 'Um pedido sem criativos adicionados só pode ser salvo como rascunho'
	},
	confirm_email: {
		en: 'Please, confirm the email before submitting your request',
		ge: 'გთხოვთ, დაადასტუროთ ელ.წერილი თქვენი მოთხოვნის გაგზავნამდე',
		de: 'Bitte bestätigen Sie die E-Mail, bevor Sie Ihre Anfrage einreichen',
		ru: 'Пожалуйста, подтвердите адрес электронной почты перед отправкой запроса',
		cn: 'Please, confirm the email before submitting your request',
		pt: 'Por favor, confirme o e-mail antes de enviar sua solicitação'
	},
	video_resolution: {
		en: 'video resolution',
		ge: 'ვიდეო გარჩევადობა',
		de: 'Videoauflösung',
		ru: 'Разрешение видео',
		cn: '视频分辨率',
		pt: 'resolução do vídeo'
	},
	video_duration: {
		en: 'video duration',
		ge: 'ვიდეოს ხანგრძლივობა',
		de: 'Videodauer',
		ru: 'Длительность видео',
		cn: '视频时长',
		pt: 'duração do vídeo'
	},
	screen_resolution: {
		en: 'screen resolution',
		ge: 'ეკრანის გარჩევადობა',
		de: 'Bildschirmauflösung',
		ru: 'разрешение устройства',
		cn: '屏幕分辨率',
		pt: 'resolução da tela'
	},
	current_status: {
		en: 'current status',
		ge: 'მიმდინარე სტატუსი',
		de: 'Aktueller Status',
		ru: 'текущий статус',
		cn: '当前状态',
		pt: 'status atual'
	},
	audit_message: {
		en: 'audit message',
		ge: 'ხდება შეტყობინების შემოწმდება',
		de: 'Auditnachricht',
		ru: 'аудит',
		cn: '审核消息',
		pt: 'mensagem de auditoria'
	},
	resolution: {
		en: 'resolution',
		ge: 'რეზოლუცია',
		de: 'Auflösung',
		ru: 'разрешение',
		cn: '分辨率',
		pt: 'resolução'
	},
	duration: {
		en: 'duration',
		ge: 'ხანგრძლივობა',
		de: 'Dauer',
		ru: 'длительность',
		cn: '时长',
		pt: 'duração'
	},
	file_size: {
		en: 'file size',
		ge: 'ფაილის ზომა',
		de: 'Dateigröße',
		ru: 'размер файла',
		cn: '文件大小',
		pt: 'tamanho do arquivo'
	},
	'delete': {
		en: 'delete',
		ge: 'delete',
		de: 'löschen',
		ru: 'удалить',
		cn: '删除',
		pt: 'excluir'
	},
	cancel: {
		en: 'cancel',
		ge: 'გაუქმება',
		de: 'abbrechen',
		ru: 'отменить',
		cn: '取消',
		pt: 'cancelar'
	},
	edit: {
		en: 'edit',
		ge: 'დეტალები',
		de: 'bearbeiten',
		ru: 'изменить',
		cn: '编辑',
		pt: 'editar'
	},
	details: {
		en: 'details',
		ge: 'details',
		de: 'Details',
		ru: 'подробности',
		cn: '详情',
		pt: 'detalhes'
	},
	upload: {
		en: 'upload',
		ge: 'ატვირთვა',
		de: 'hochladen',
		ru: 'загрузить',
		cn: '上传',
		pt: 'carregar'
	},
	uploaded: {
		en: 'uploaded',
		ge: 'ატვირთული',
		de: 'hochgeladen',
		ru: 'загружено',
		cn: '已上传',
		pt: 'carregado'
	},
	cancel_uploading: {
		en: 'cancel uploading',
		ge: 'ატვირთვის გაუქმება',
		de: 'Hochladen abbrechen',
		ru: 'остановить загрузку',
		cn: '取消上传',
		pt: 'cancelar carregamento'
	},
	edit_details: {
		en: 'edit details',
		ge: 'დეტალების რედაქტირება',
		de: 'Details bearbeiten',
		ru: 'редактировать',
		cn: '编辑详情',
		pt: 'editar detalhes'
	},
	see_details: {
		en: 'see details',
		ge: 'იხილეთ დეტალები',
		de: 'Details ansehen',
		ru: 'подробнee',
		cn: '查看详情',
		pt: 'ver detalhes'
	},
	created_by: {
		en: 'created by',
		ge: 'შექმნილი',
		de: 'erstellt von',
		ru: 'разместил',
		cn: '创建者',
		pt: 'criado por'
	},
	uploaded_by: {
		en: 'uploaded by',
		ge: 'ატვირთული',
		de: 'hochgeladen von',
		ru: 'загрузил',
		cn: '上传者',
		pt: 'carregado por'
	},
	creative_status_waiting: {
		en: 'waiting',
		ge: 'ვლოდებია',
		de: 'wartet',
		ru: 'ожидание',
		cn: '正在等待',
		pt: 'aguardando'
	},
	creative_status_canceled: {
		en: 'canceled',
		ge: 'გაუქმდა',
		de: 'abgebrochen',
		ru: 'отменен',
		cn: '已取消',
		pt: 'cancelado'
	},
	creative_status_uploading: {
		en: 'uploading',
		ge: 'ატვირთვა',
		de: 'lädt hoch',
		ru: 'загружается',
		cn: '正在上传',
		pt: 'carregando'
	},
	creative_status_uploaded: {
		en: 'uploaded',
		ge: 'ატვირთული',
		de: 'hochgeladen',
		ru: 'загружено',
		cn: '已上传',
		pt: 'carregado'
	},
	creative_status_failed: {
		en: 'failed',
		ge: 'ჩაიშალა',
		de: 'fehlgeschlagen',
		ru: 'неудача',
		cn: '失败',
		pt: 'falhou'
	},
	creative_audit_status_pending_audit: {
		en: 'pending audit',
		ge: 'ელოდება შემოწმებას',
		de: 'Audit ausstehend',
		ru: 'ожидается аудит',
		cn: '正在审核',
		pt: 'auditoria pendente'
	},
	creative_audit_status_pre_approved: {
		en: 'pre approved',
		ge: 'წინასწარ დამტკიცებული',
		de: 'vorab genehmigt',
		ru: 'предварительно одобрено',
		cn: '已预审批',
		pt: 'pré-aprovado'
	},
	creative_audit_status_approved: {
		en: 'approved',
		ge: 'დამტკიცებული',
		de: 'genehmigt',
		ru: 'одобрено',
		cn: '已审批',
		pt: 'aprovado'
	},
	creative_audit_status_rejected: {
		en: 'rejected',
		ge: 'უარყოფილი',
		de: 'abgelehnt',
		ru: 'отклонено',
		cn: '已驳回',
		pt: 'rejeitado'
	},
	creative_audit_status_changed: {
		en: 'changed',
		ge: 'შეცვლილი',
		de: 'geändert',
		ru: 'изменено',
		cn: '已更改',
		pt: 'alterado'
	},
	creative_audit_status_expired: {
		en: 'expired',
		ge: 'ვადაგასული',
		de: 'abgelaufen',
		ru: 'устарело',
		cn: '已过期',
		pt: 'expirado'
	},
	status_resetting_reason: {
		en: 'status pending reason',
		ge: 'სტატუსის მომლოდინე მიზეზი',
		de: 'Status ausstehender Grund',
		ru: 'причина ожидания подтверждения',
		cn: '状态为正在审核的原因',
		pt: 'razão para pendência do status'
	},
	pending_reason: {
		en: 'status pending reason',
		ge: 'სტატუსის მომლოდინე მიზეზი',
		de: 'Status ausstehender Grund',
		ru: 'причина ожидания подтверждения',
		cn: '状态为正在审核的原因',
		pt: 'razão para pendência do status'
	},
	pre_approvement_reason: {
		en: 'pre approvement',
		ge: 'წინასწარ დამტკიცება',
		de: 'Vorabgenehmigung',
		ru: 'причина предварительного подтверждения',
		cn: '预审批',
		pt: 'pré-aprovação'
	},
	approvement_reason: {
		en: 'approvement reason',
		ge: 'დამტკიცების მიზეზი',
		de: 'Genehmigungsgrund',
		ru: 'причина подтверждения',
		cn: '审批原因',
		pt: 'razão para aprovação'
	},
	rejection_reason: {
		en: 'rejection reason',
		ge: 'უარის მიზეზი',
		de: 'Ablehnungsgrund',
		ru: 'причина отказа',
		cn: '驳回原因',
		pt: 'razão para rejeição'
	},
	resubmition_requirement_reason: {
		en: 'resubmition requirement reason',
		ge: 'ხელახლა წარდგენის მოთხოვნის მიზეზი',
		de: 'Gründe für die erneute Einreichung',
		ru: 'причина повторной отправки',
		cn: '要求重新提交的原因',
		pt: 'razão para exigir reenvio'
	},
	expiration_reason: {
		en: 'expiration reason',
		ge: 'გადასვლის მიზეზი',
		de: 'Ablaufgrund',
		ru: 'причина истечения срока ',
		cn: '过期原因',
		pt: 'razão para expiração'
	},
	of: {
		en: 'of',
		ge: 'დან',
		de: 'von',
		ru: '',
		cn: '的',
		pt: 'de'
	},
	reset_to_pending: {
		en: 'reset to pending',
		ge: 'მოლოდინში დაყენება',
		de: 'Zurücksetzen auf ausstehend',
		ru: 'сбросить на ожидание',
		cn: '重置为正在审核',
		pt: 'reiniciar para pendente'
	},
	creative_audit_action_reset_to_pending: {
		en: 'reset to pending',
		ge: 'მოლოდინში დაყენება',
		de: 'Zurücksetzen auf ausstehend',
		ru: 'сбросить на ожидание',
		cn: '重置为正在审核',
		pt: 'reiniciar para pendente'
	},
	creative_audit_action_pre_approve: {
		en: 'pre approve',
		ge: 'წინასწარ დამტკიცება',
		de: 'vorab genehmigen',
		ru: 'предварительно подтвердить',
		cn: '预审批',
		pt: 'pré-aprovar'
	},
	creative_audit_action_approve: {
		en: 'approve',
		ge: 'დამტკიცება',
		de: 'genehmigen',
		ru: 'подтвердить',
		cn: '审批',
		pt: 'aprovar'
	},
	creative_audit_action_reject: {
		en: 'reject',
		ge: 'უარი',
		de: 'ablehnen',
		ru: 'отклонить',
		cn: '驳回',
		pt: 'rejeitar'
	},
	creative_audit_action_require_resubmition: {
		en: 'require resubmition',
		ge: 'მოითხოვე ხელახლა გაგზავნა',
		de: 'erneute Einreichung erforderlich',
		ru: 'запросить повторную отправку',
		cn: '要求重新提交',
		pt: 'exigir reenvio'
	},
	creative_audit_action_set_to_expired: {
		en: 'set to expired',
		ge: 'დაყენებულია ვადაგასულად',
		de: 'als abgelaufen markieren',
		ru: 'пометить как просроченный',
		cn: '设置为已过期',
		pt: 'definir como expirado'
	},
	changed: {
		en: 'changed',
		ge: 'შეცვლილი',
		de: 'geändert',
		ru: 'изменено',
		cn: '已更改',
		pt: 'alterado'
	},
	changed_by: {
		en: 'changed by',
		ge: 'შეცვლილია',
		de: 'geändert von',
		ru: 'изменил',
		cn: '更改者',
		pt: 'alterado por'
	},
	creative_audit_action_noun_status_resetting: {
		en: 'reset to pending',
		ge: 'მოლოდინში დაყენებ',
		de: 'Zurücksetzen auf ausstehend',
		ru: 'сбросить на ожидание',
		cn: '重置为正在审核',
		pt: 'reiniciar para pendente'
	},
	creative_audit_action_noun_pre_approvement: {
		en: 'pre approvement',
		ge: 'წინასწარ დამტკიცებაt',
		de: 'Vorabgenehmigung',
		ru: 'предварительное подтверждение',
		cn: '预审批',
		pt: 'pré-aprovação'
	},
	creative_audit_action_noun_approvement: {
		en: 'approvement',
		ge: 'დამტკიცება',
		de: 'Genehmigung',
		ru: 'подтверждение',
		cn: '审批',
		pt: 'aprovação'
	},
	creative_audit_action_noun_rejection: {
		en: 'rejection',
		ge: 'უარი',
		de: 'Ablehnung',
		ru: 'отклонение',
		cn: '驳回',
		pt: 'rejeição'
	},
	creative_audit_action_noun_resubmition_requirement: {
		en: 'resubmition requirement',
		ge: 'მოითხოვე ხელახლა გაგზავნა',
		de: 'Erneute Einreichung erforderlich',
		ru: 'запрос повторной отправки',
		cn: '重新提交要求',
		pt: 'exigência de reenvio'
	},
	creative_audit_action_noun_expiration: {
		en: 'expiration',
		ge: 'ვადის გასვლა',
		de: 'Ablauf',
		ru: 'истечение',
		cn: '过期',
		pt: 'expiração'
	},
	// pre_approved
	status_change_2: {
		en: 'pre approved',
		ge: 'წინასწარ დამტკიცებული',
		de: 'vorab genehmigt',
		ru: 'предварительно утверждено',
		cn: 'pre approved',
		pt: 'pré-aprovado'
	},
	// old?
	status_change_approved: {
		en: 'approved',
		ge: 'დამტკიცებული',
		de: 'genehmigt',
		ru: 'подтверждено',
		cn: '已审批',
		pt: 'aprovado'
	},
	// pre_approved
	pre_approve: {
		en: 'pre approve',
		ge: 'წინასწარ დამტკიცება',
		de: 'vorab genehmigen',
		ru: 'предварительно утвердить',
		cn: 'pre approve',
		pt: 'pré-aprovar'
	},
	status_change_2_action: {
		en: 'pre approve',
		ge: 'წინასწარ დამტკიცება',
		de: 'vorab genehmigen',
		ru: 'предварительно утвердить',
		cn: 'pre approve',
		pt: 'pré-aprovar'
	},
	// playing
	status_change_3: {
		en: 'playing',
		ge: 'ჩართვა',
		de: 'wird abgespielt',
		ru: 'проигрывается',
		cn: '正在播放',
		pt: 'em reprodução'
	},
	status_change_531: {
		en: 'awaiting approval',
		ge: 'დამტკიცების მოლოდინში',
		de: 'Warten auf Genehmigung',
		ru: 'ожидание подтверждения',
		cn: '正在等待审批',
		pt: 'aguardando aprovação'
	},
	status_change_532: {
		en: 'playing only approved',
		ge: 'ჩართულია მხოლოდ დამტკიცებული',
		de: 'nur genehmigte werden abgespielt',
		ru: 'проигрываются только подтвержденные',
		cn: 'playing only approved',
		pt: 'reproduzindo apenas os aprovados'
	},
	// playing
	status_change_3_action: {
		en: 'to playing',
		ge: 'ჩართვა',
		de: 'abspielen',
		ru: 'запустить',
		cn: '播放',
		pt: 'para reproduzir'
	},
	// paused
	status_change_692: {
		en: 'paused',
		ge: 'შეჩერებულია',
		de: 'pausiert',
		ru: 'приостановлено',
		cn: '已暂停',
		pt: 'pausado'
	},
	// paused
	status_change_692_action: {
		en: 'pause',
		ge: 'პაუზა',
		de: 'pausieren',
		ru: 'приостановить',
		cn: '暂停',
		pt: 'pausar'
	},
	// finished
	status_change_693: {
		en: 'finished',
		ge: 'დასრულებულია',
		de: 'beendet',
		ru: 'завершено',
		cn: '已完成',
		pt: 'finalizado'
	},
	// finished
	status_change_693_action: {
		en: 'finish',
		ge: 'დასრულება',
		de: 'beenden',
		ru: 'завершить',
		cn: '完成',
		pt: 'finalizar'
	},
	// awaiting_approval
	status_change_1: {
		en: 'awaiting approval',
		ge: 'ელოდებია დამტკიცებას',
		de: 'Warten auf Genehmigung',
		ru: 'ожидание подтверждения',
		cn: '正在等待审批',
		pt: 'aguardando aprovação'
	},
	// awaiting_approval
	status_change_1_action: {
		en: 'send to approve',
		ge: 'გაგზავნა დასამტკიცებლად',
		de: 'zur Genehmigung senden',
		ru: 'отправить на подтверждение',
		cn: '发送审批请求',
		pt: 'enviar para aprovação'
	},
	// rejected
	status_change_4: {
		en: 'rejected',
		ge: 'უარყოფილი',
		de: 'abgelehnt',
		ru: 'отклонено',
		cn: '已驳回',
		pt: 'rejeitado'
	},
	// rejected
	status_change_4_action: {
		en: 'reject',
		ge: 'უარი',
		de: 'ablehnen',
		ru: 'отклонить',
		cn: '驳回',
		pt: 'rejeitar'
	},
	// archived
	status_change_694: {
		en: 'archived',
		ge: 'არქივირებული',
		de: 'archiviert',
		ru: 'в архиве',
		cn: '已存档',
		pt: 'arquivado'
	},
	// archived
	status_change_694_action: {
		en: 'archive',
		ge: 'არქივი',
		de: 'archivieren',
		ru: 'архивировать',
		cn: '存档',
		pt: 'arquivar'
	},
	// deleted
	status_change_695: {
		en: 'deleted',
		ge: 'წაშლილი',
		de: 'gelöscht',
		ru: 'удалено',
		cn: '已删除',
		pt: 'excluído'
	},
	// deleted
	status_change_695_action: {
		en: 'delete',
		ge: 'წაშლა',
		de: 'löschen',
		ru: 'удалить',
		cn: '删除',
		pt: 'excluir'
	},
	all_campaigns: {
		en: 'all campaigns',
		ge: 'ყველა კამპანია',
		de: 'alle Kampagnen',
		ru: 'все кампании',
		cn: '所有活动',
		pt: 'todas as campanhas'
	},
	campaigns: {
		en: 'campaigns',
		ge: 'კამპანიები',
		de: 'Kampagnen',
		ru: 'кампании',
		cn: 'campaigns',
		pt: 'campanhas'
	},
	status_change_draft: {
		en: 'draft',
		ge: 'მონახაზი',
		de: 'Entwurf',
		ru: 'черновик',
		cn: '草稿',
		pt: 'rascunho'
	},
	status_change_reviewing: {
		en: 'reviewing',
		ge: 'მიმოხილვა',
		de: 'wird überprüft',
		ru: 'пересматривается',
		cn: '正在审阅',
		pt: 'em revisão'
	},
	status_change_failed: {
		en: 'status change failed',
		ge: 'სტატუსის შეცვლა ვერ მოხერხდა',
		de: 'Statusänderung fehlgeschlagen',
		ru: 'не удалось изменить статус',
		cn: '无法更改状态',
		pt: 'falha na alteração de status'
	},
	request_review_subtitle: {
		en: 'From {company} by {manager}',
		ge: '{company}დან {manager}ის მიერ',
		de: 'Von {company} durch {manager}',
		ru: 'Создано {company}, пользователем {manager}',
		cn: '审阅人：{company} {manager}',
		pt: 'De {company} por {manager}'
	},
	play: {
		en: 'play',
		ge: 'ჩართვა',
		de: 'abspielen',
		ru: 'запустить',
		cn: '播放',
		pt: 'reproduzir'
	},
	pause: {
		en: 'pause',
		ge: 'პაუზა',
		de: 'pausieren',
		ru: 'приостановить',
		cn: '暂停',
		pt: 'pausar'
	},
	approve: {
		en: 'approve',
		ge: 'დამტკიცება',
		de: 'genehmigen',
		ru: 'принять',
		cn: '审批',
		pt: 'aprovar'
	},
	reject: {
		en: 'reject',
		ge: 'უარი',
		de: 'ablehnen',
		ru: 'отклонить',
		cn: '驳回',
		pt: 'rejeitar'
	},
	archive: {
		en: 'archive',
		ge: 'არქივი',
		de: 'archivieren',
		ru: 'архивировать',
		cn: '存档',
		pt: 'arquivar'
	},
	details_tab: {
		en: 'details',
		ge: 'დეტალები',
		de: 'Details',
		ru: 'подробности',
		cn: '详情',
		pt: 'detalhes'
	},
	order_tab: {
		en: 'order',
		ge: 'შეკვეთა',
		de: 'Bestellung',
		ru: 'заказ',
		cn: '订单',
		pt: 'pedido'
	},
	creative_tab: {
		en: 'creative',
		ge: 'შემოქმედება',
		de: 'Kreativ',
		ru: 'креатив',
		cn: '广告内容',
		pt: 'criativo'
	},
	status_tab: {
		en: 'status',
		ge: 'სტატუსი',
		de: 'Status',
		ru: 'статус',
		cn: '状态',
		pt: 'status'
	},
	history_tab: {
		en: 'Changes',
		ge: 'Changes',
		de: 'Changes',
		ru: 'Изменения',
		cn: 'Changes',
		pt: 'alterações'
	},
	seller_name: {
		en: 'seller\'s name',
		ge: 'გამყიდველის სახელი',
		de: 'Name des Verkäufers',
		ru: 'рекламодатель',
		cn: '销售商名称',
		pt: 'nome do vendedor'
	},
	contact_number: {
		en: 'contact number',
		ge: 'საკონტაქტო ნომერი',
		de: 'Kontaktnummer',
		ru: 'номер для связи',
		cn: '联系电话',
		pt: 'número de contato'
	},
	client_id: {
		en: 'client id (contract)',
		ge: 'კლიენტის ID  (კონტრაქტი)',
		de: 'Kunden-ID (Vertrag)',
		ru: 'контракт',
		cn: '客户 ID（合同）',
		pt: 'ID do cliente (contrato)'
	},
	email: {
		en: 'email',
		ge: 'ელფოსტა',
		de: 'E-Mail',
		ru: 'email',
		cn: '电子邮箱',
		pt: 'e-mail'
	},
	description: {
		en: 'description',
		ge: 'აღწერილობა',
		de: 'Beschreibung',
		ru: 'описание',
		cn: '描述',
		pt: 'descrição'
	},
	description_placeholder: {
		en: 'description',
		ge: 'აღწერილობა',
		de: 'Beschreibung',
		ru: 'описание',
		cn: 'description',
		pt: 'descrição'
	},
	brand_placeholder: {
		en: 'brand',
		ge: 'ბრენდი',
		de: 'Marke',
		ru: 'бренд',
		cn: 'brand',
		pt: 'marca'
	},
	brand_label: {
		en: 'brand',
		ge: 'ბრენდი',
		de: 'Marke',
		ru: 'бренд',
		cn: 'brand',
		pt: 'marca'
	},
	ad_duration: {
		en: 'ad duration',
		ge: 'რეკლამის ხანგრძლივობა',
		de: 'Anzeigendauer',
		ru: 'длительность',
		cn: '广告时长',
		pt: 'duração do anúncio'
	},
	company: {
		en: 'company',
		ge: 'კომპანია',
		de: 'Firma',
		ru: 'компания',
		cn: '公司',
		pt: 'empresa'
	},
	industry: {
		en: 'industry',
		ge: 'ინდუსტრია',
		de: 'Industrie',
		ru: 'индустрия',
		cn: '行业',
		pt: 'indústria'
	},
	all: {
		en: 'all',
		ge: 'ყველა',
		de: 'alle',
		ru: 'все',
		cn: '全部',
		pt: 'todos'
	},
	max_bid_extra_detail: {
		en: 'for a {message_duration} creative',
		ge: '{message_duration} შექმნისთვის',
		de: 'für ein {message_duration} Kreativ',
		ru: 'для креатива в {message_duration}',
		cn: '针对时长为 {message_duration} 的广告内容',
		pt: 'para um criativo de {message_duration}'
	},
	widget_ad_plays_title: {
		en: 'Ad Plays',
		ge: 'რეკლამის გაშვება',
		de: 'Ad Plays',
		ru: 'Показы',
		cn: '广告播放',
		pt: 'Reproduções de Anúncio'
	},
	widget_impressions_title: {
		en: 'Impressions',
		ge: 'შთაბეჭდილებები',
		de: 'Impressionen',
		ru: 'Охват',
		cn: '展示',
		pt: 'Impressões'
	},
	widget_inventory_title: {
		en: 'Inventory',
		ge: 'ინვენტარი',
		de: 'Inventar',
		ru: 'Точки вещания',
		cn: '清单',
		pt: 'Inventário'
	},
	widget_budget_label: {
		en: 'ordered',
		ge: 'შეკვეთა',
		de: 'bestellt',
		ru: 'забронировано',
		cn: '已提交订单',
		pt: 'encomendado'
	},
	widget_ad_plays_hint: {
		en: 'This is the forecast ad&nbsp;plays quantity that based on your rules and budget.',
		ge: 'ეს არის რეკლამის პროგნოზირება&nbsp;თამაშების რაოდენობა, რომელიც ეფუძნება თქვენს წესებსა და ბიუჯეტს.',
		de: 'Dies ist die prognostizierte Anzahl der Anzeigenschaltungen basierend auf Ihren Regeln und Ihrem Budget.',
		ru: 'Прогноз на количество показов для выбранных правил и бюджета.',
		cn: '这是根据您的规则和预算预测的广告播放次数。',
		pt: 'Esta é a quantidade prevista de reproduções de anúncio com base nas suas regras e orçamento.'
	},
	widget_ad_plays_max_hint: {
		en: 'This is the maximum ad plays quantity that based on your rules and in case of maximum budget.',
		ge: 'ეს არის რეკლამის დაკვრის მაქსიმალური რაოდენობა, რომელიც ეფუძნება თქვენს წესებს და მაქსიმალური ბიუჯეტის შემთხვევაში.',
		de: 'Dies sind die maximalen Anzeigenschaltungen basierend auf Ihren Regeln und bei maximalem Budget.',
		ru: 'Возможный максимум показов для выбранных правил при максимальном бюджете.',
		cn: '这是根据您的规则，在预算达到上限时广告最多播放的次数。',
		pt: 'Esta é a quantidade máxima de reproduções de anúncio com base nas suas regras e no caso de orçamento máximo.'
	},
	widget_budgeted_label: {
		en: 'ordered',
		ge: 'ბრძანება',
		de: 'bestellt',
		ru: 'забронировано',
		cn: '已提交订单',
		pt: 'encomendado'
	},
	widget_impressions_hint: {
		en: 'This is the forecast impressions that based on your rules and budget.',
		ge: 'ეს არის შთაბეჭდილებების პროგნოზი, რომელიც ეფუძნება თქვენს წესებსა და ბიუჯეტს.',
		de: 'Dies sind die prognostizierten Impressionen basierend auf Ihren Regeln und Ihrem Budget.',
		ru: 'Прогноз аудитории для выбранных правил и бюджета.',
		cn: '这是根据您的规则和预算预测的展示次数。',
		pt: 'Estas são as impressões previstas com base nas suas regras e orçamento.'
	},
	widget_impressions_max_hint: {
		en: 'This is the maximum impressions that based on your rules and in case of maximum budget.',
		ge: 'ეს არის მაქსიმალური შთაბეჭდილებები, რაც გამომდინარეობს თქვენი წესებიდან მაქსიმალური ბიუჯეტის შემთხვევაში.',
		de: 'Dies sind die maximalen Impressionen basierend auf Ihren Regeln und bei maximalem Budget.',
		ru: 'Максимально возможная аудитория для выбранных правил при максимальном бюджете.',
		cn: '这是根据您的规则，在预算达到上限时的最多展示次数。',
		pt: 'Estas são as impressões máximas com base nas suas regras e no caso de orçamento máximo.'
	},
	widget_selected_label: {
		en: 'selected',
		ge: 'შერჩეული',
		de: 'ausgewählt',
		ru: 'выбрано',
		cn: '已选择',
		pt: 'selecionado'
	},
	widget_inventory_hint: {
		en: 'Broadcast points quantity accessible for this campaign. Based on your rules and budget.',
		ge: 'სამაუწყებლო წერტილების რაოდენობა ხელმისაწვდომია ამ კამპანიისთვის. თქვენი წესებისა და ბიუჯეტიდან გამომდინარე.',
		de: 'Anzahl der Übertragungspunkte, die für diese Kampagne zugänglich sind. Basierend auf Ihren Regeln und Ihrem Budget.',
		ru: 'Точек вещания доступных для этой кампании. Основано на выбранных правилах и бюджете.',
		cn: '这是根据您的规则和预算，此活动可以投放的播放点数量。',
		pt: 'Quantidade de pontos de exibição disponíveis para esta campanha, com base nas suas regras e orçamento.'
	},
	widget_inventory_max_hint: {
		en: 'All accessible broadcast points quantity based on your rules and in case of maximum budget.',
		ge: 'ყველა ხელმისაწვდომი სამაუწყებლო წერტილების რაოდენობა თქვენი წესების მიხედვით და მაქსიმალური ბიუჯეტის შემთხვევაში.',
		de: 'Alle zugänglichen Übertragungspunkte basierend auf Ihren Regeln und bei maximalem Budget.',
		ru: 'Все доступные точки вещания доступные при выбранных правилах в случае максимального бюджета.',
		cn: '这是根据您的规则，在预算达到上限时可以投放的所有播放点数量。',
		pt: 'Quantidade total de pontos de exibição disponíveis com base nas suas regras e no caso de orçamento máximo.'
	},
	widget_requirements_label: {
		en: 'Creative Requirement',
		ge: 'შექმნის მოთხოვნა',
		de: 'Kreative Anforderung',
		ru: 'Форматы',
		cn: '广告内容要求',
		pt: 'Requisito do criativo'
	},
	widget_specs: {
		en: 'specs',
		ge: 'სპეციფიკაციები',
		de: 'Spezifikationen',
		ru: 'разрешения',
		cn: '属性',
		pt: 'especificações'
	},
	widget_points: {
		en: 'points',
		ge: 'წერტილები',
		de: 'Punkte',
		ru: 'точки вещания',
		cn: '点',
		pt: 'pontos'
	},
	available: {
		en: 'available',
		ge: 'ხელმისაწვდომია',
		de: 'verfügbar',
		ru: 'доступно',
		cn: '可用',
		pt: 'disponível'
	},
	points: {
		en: 'points',
		ge: 'წერტილები',
		de: 'Punkte',
		ru: 'точки',
		cn: '点',
		pt: 'pontos'
	},
	impressions: {
		en: 'impressions',
		ge: 'შთაბეჭდილებები',
		de: 'Impressionen',
		ru: 'аудитория',
		cn: '展示',
		pt: 'impressões'
	},
	ad_plays: {
		en: 'Ad plays',
		ge: 'რეკლამის ჩართვა',
		de: 'Ad Plays',
		ru: 'Показы',
		cn: '广告播放',
		pt: 'reproduções de anúncio'
	},
	sel_impressions: {
		en: 'impressions',
		ge: 'შთაბეჭდილებები',
		de: 'Impressionen',
		ru: 'аудитория',
		cn: '展示',
		pt: 'impressões'
	},
	sel_spent: {
		en: 'spent',
		ge: 'დახარჯული',
		de: 'ausgegeben',
		ru: 'потрачено',
		cn: '已花费',
		pt: 'gasto'
	},
	sel_ad_plays: {
		en: 'ad_plays',
		ge: 'რეკლამის ჩართვა',
		de: 'Anzeigenschaltungen',
		ru: 'показов',
		cn: '广告播放',
		pt: 'reproduções de anúncio'
	},
	no_creative_specified: {
		en: 'No creative specified',
		ge: 'შექმნილები არ არის მითითებული',
		de: 'Kein kreativer Inhalt angegeben',
		ru: 'Нет прикреплённых креативов',
		cn: '没有指定广告内容',
		pt: 'Nenhum criativo especificado'
	},
	step04_no_devices: {
		en: 'No devices are matching the filter',
		ge: 'არცერთი მოწყობილობა არ ემთხვევა ფილტრს',
		de: 'Keine Geräte entsprechen dem Filter',
		ru: 'Нет устройств, удовлетворяющих фильтру',
		cn: '没有符合筛选条件的设备',
		pt: 'Nenhum dispositivo corresponde ao filtro'
	},
	download_broadcasting_report: {
		en: 'Broadcasting report',
		ge: 'მაუწყებლობის ანგარიში',
		de: 'Übertragungsbericht',
		ru: 'Эфирная справка',
		cn: '播放报告',
		pt: 'relatório de exibição'
	},
	download_campaign_report: {
		en: 'Campaign report',
		ge: 'Campaign report',
		de: 'Campaign report',
		ru: 'Отчет о кампаниях',
		cn: 'Campaign report',
		pt: 'relatório de campanha'
	},
	report_generation_started: {
		en: 'Report generation started. You will recieve an email when it is done.',
		ge: 'ანგარიშების შექმნა დაიწყო. თქვენ მიიღებთ ელ.წერილს, როდესაც ეს დასრულდება.',
		de: 'Berichtsgenerierung gestartet. Sie erhalten eine E-Mail, wenn dies abgeschlossen ist.',
		ru: 'Отчет генерируется. Вы получите уведомление на почту, когда он будет готов.',
		cn: '开始生成报告。报告生成完毕后您将收到电子邮件。',
		pt: 'A geração do relatório foi iniciada. Você receberá um e-mail quando estiver concluído.'
	},
	report_generation_failed: {
		en: 'Report generation failed! Please, try again later.',
		ge: 'ანგარიშის შექმნა ვერ მოხერხდა! გთხოვთ, სცადოთ მოგვიანებით.',
		de: 'Berichtsgenerierung fehlgeschlagen! Bitte versuchen Sie es später noch einmal.',
		ru: 'Не удалось сгенерировать ответ. Пожалуйста, попробуйте позже.',
		cn: 'Report generation failed! Please, try again later.',
		pt: 'Falha na geração do relatório! Por favor, tente novamente mais tarde.'
	},
	clear_selection_confirmation_text: {
		en: 'Are you sure you want to clear selected options?',
		ge: 'დარწმუნებული ხართ, რომ გსურთ არჩეული ვარიანტების გასუფთავება?',
		de: 'Sind Sie sicher, dass Sie die ausgewählten Optionen löschen möchten?',
		ru: 'Вы уверены, что хотите очистить выбранные опции?',
		cn: 'Are you sure you want to clear selected options?',
		pt: 'Tem certeza de que deseja limpar as opções selecionadas?'
	},
	open_inventory_modal: {
		en: 'Show inventory details',
		ge: 'ინვენტარის დეტალების ჩვენება',
		de: 'Inventardetails anzeigen',
		ru: 'Показать точки вещания',
		cn: 'Show inventory details',
		pt: 'Mostrar detalhes do inventário'
	},
	inventory_modal_hint: {
		en: 'See the platform\'s broadcasting points, control a black-/whitelist, export request\'s broadcasting point\'s list',
		ge: 'იხილეთ პლატფორმის სამაუწყებლო წერტილები, აკონტროლეთ შავი/თეთრი სია, მოთხოვნის ექსპორტის სამაუწყებლო პუნქტის სია',
		de: 'Sehen Sie die Übertragungspunkte der Plattform, verwalten Sie eine schwarze/weiße Liste, exportieren Sie die Liste der Übertragungspunkte der Anfrage',
		ru: 'Просмотр устройств платформы, управление чёрным и белым списком, экспорт списка устройств',
		cn: 'This option allows you to see the platform\'s broadcasting points, control a blacklist/whitelist, and export the list of broadcasting points for the request.',
		pt: 'Veja os pontos de exibição da plataforma, controle uma lista negra/branca e exporte a lista de pontos de exibição da solicitação'
	},
	campaign_edit: {
		en: 'Edit campaign',
		ge: 'კამპანიის რედაქტირება',
		de: 'Kampagne bearbeiten',
		ru: 'Редактировать кампанию',
		cn: 'Edit campaign',
		pt: 'Editar campanha'
	},
	fixed_placement: {
		en: 'Fixed placement without auction',
		ge: 'ფიქსირებული განთავსება აუქციონის გარეშე',
		de: 'Feste Platzierung ohne Auktion',
		ru: 'Фиксированное размещение без аукциона',
		cn: 'Fixed placement without auction',
		pt: 'Posicionamento fixo sem leilão'
	},
	fixed_cost: {
		en: 'Fixed cost',
		ge: 'ფიქსირებული ღირებულება',
		de: 'Feste Kosten',
		ru: 'Фиксированная цена',
		cn: 'Fixed cost',
		pt: 'Custo fixo'
	},
	impressions_forecast: {
		en: 'Impressions Forecast',
		ge: 'ჩვენებების პროგნოზი',
		de: 'Impressions-Prognose',
		ru: 'Прогноз показов',
		cn: 'Impressions Forecast',
		pt: 'Previsão de Impressões'
	},
	budget_is_daily_hint: {
		en: 'The maximum amount that can be used to display a campaign within one day.',
		ge: 'ერთი დღის განმავლობაში კამპანიის ჩვენებისთვის გამოყენებული მაქსიმალური თანხა.',
		de: 'Der Höchstbetrag, der zur Ausspielung einer Kampagne innerhalb eines Tages verwendet werden kann.',
		ru: 'Максимальная сумма, которую можно использовать для показа кампании в течение одного дня.',
		cn: '在一天内用于展示广告系列的最高金额。',
		pt: 'O valor máximo que pode ser usado para exibir uma campanha em um único dia.'
	},
	fixed_placement_hint: {
		en: 'You can buy ads with a reservation at a fixed price for a thousand impressions (CPT or Ad plays), a thousand contacts (CPM), a set number of guaranteed views (CPV). If you select this option, the campaign will be played without participating in the auction. With the help of reservation, you can increase brand awareness, offer a new product or service, as well as a rebrand.',
		ge: 'შეგიძლიათ იყიდოთ რეკლამები, დაჯავშნით ფიქსირებულ ფასად, ათასი შთაბეჭდილებისთვის (CPT ან რეკლამის დაკვრა), ათასი კონტაქტის (CPM), გარანტირებული ნახვების დადგენილ რაოდენობაზე (CPV). თუ აირჩევთ ამ ვარიანტს, კამპანია იმუშავებს აუქციონში მონაწილეობის გარეშე. დაჯავშნის დახმარებით შეგიძლიათ გაზარდოთ ბრენდის ცნობადობა, შესთავაზოთ ახალი პროდუქტი ან სერვისი.',
		de: 'Sie können Anzeigen mit einer Reservierung zu einem festen Preis für tausend Impressionen (CPT oder Ad plays), tausend Kontakte (CPM), eine festgelegte Anzahl garantierter Aufrufe (CPV) kaufen. Wenn Sie diese Option auswählen, wird die Kampagne ohne Teilnahme an der Auktion abgespielt. Mit Hilfe der Reservierung können Sie die Markenbekanntheit steigern, ein neues Produkt oder eine neue Dienstleistung anbieten sowie ein Rebranding durchführen.',
		ru: 'Вы можете покупать рекламу с резервированием по фиксированной цене за: тысячу показов (CPT или Ad plays), тысячу контактов (CPM), установленное количество гарантированных просмотров (CPV). При выборе этой опции кампания будет проигрываться без участия в аукционе. С помощью резервирования можно повысить узнаваемость бренда, предложить новый товар или услугу, а также провести ребрендинг.',
		cn: 'You can buy ads with a reservation at a fixed price for a thousand impressions (CPT or Ad plays), a thousand contacts (CPM), a set number of guaranteed views (CPV). If you select this option, the campaign will be played without participating in the auction. With the help of reservation, you can increase brand awareness, offer a new product or service, as well as a rebrand.',
		pt: 'Você pode comprar anúncios com reserva por um preço fixo para mil impressões (CPT ou reproduções de anúncio), mil contatos (CPM) ou um número determinado de visualizações garantidas (CPV). Se você selecionar esta opção, a campanha será veiculada sem participar do leilão. Com a reserva, você pode aumentar o reconhecimento da marca, oferecer um novo produto ou serviço, além de realizar um rebranding.'
	},
	per_day: {
		en: 'Per day',
		ge: 'დღეში',
		de: 'Pro Tag',
		ru: 'В день',
		cn: 'Per day',
		pt: 'Por dia'
	},
	impressions_per_day: {
		en: 'Total impressions per day',
		ge: 'მთლიანი შთაბეჭდილებები დღეში',
		de: 'Gesamtimpressionen pro Tag',
		ru: 'Всего показов в день',
		cn: 'Total impressions per day',
		pt: 'Total de impressões por dia'
	},
	impressions_per_day_hint: {
		en: 'The number of impressions per day is calculated based on the parameters you selected.',
		ge: 'დღეში ჩვენებების რაოდენობა გამოითვლება თქვენ მიერ არჩეული პარამეტრების მიხედვით.',
		de: 'Die Anzahl der Impressionen pro Tag wird basierend auf den von Ihnen ausgewählten Parametern berechnet.',
		ru: 'Количество показов в день рассчитано на основе выбранных вами параметров.',
		cn: 'The number of impressions per day is calculated based on the parameters you selected.',
		pt: 'O número de impressões por dia é calculado com base nos parâmetros que você selecionou.'
	},
	impressions_total_with_days_of_week_hint: {
		en: 'Accounting for selected days of week',
		ge: 'კვირის შერჩეული დღეების აღრიცხვა',
		de: 'Berücksichtigung der ausgewählten Wochentage',
		ru: 'С учетом ограничений по дням недели',
		cn: 'Accounting for selected days of week',
		pt: 'Considerando os dias da semana selecionados'
	},
	balance_ssp_hint: {
		en: 'Revenue from your SSP account.',
		ge: 'შემოსავლები თქვენი SSP ანგარიშიდან.',
		de: 'Einnahmen von Ihrem SSP-Konto.',
		ru: 'Выручка вашего SSP аккаунта с программатик продаж рекламы.',
		cn: 'Revenue from your SSP account.',
		pt: 'Receita da sua conta SSP.'
	},
	requests_ssp_hint: {
		en: 'Requests from programmatic buyers by status. The faster you will approve and transferred to the “Campaign " status, the more money you will earn.',
		ge: 'მოთხოვნები პროგრამის მყიდველებისგან სტატუსის მიხედვით. რაც უფრო სწრაფად დაამტკიცებთ და გადარიცხავთ „კამპანიის“ სტატუსს, მით მეტ ფულს გამოიმუშავებთ.',
		de: 'Anfragen von programmatischen Käufern nach Status. Je schneller Sie genehmigen und in den Status „Kampagne“ überführen, desto mehr Geld verdienen Sie.',
		ru: 'Заявки от покупателей программатик рекламы с делением по статусам. Чем быстрее они будут одобрены и переведены в статус “Кампания”, тем больше вы заработаете денег.',
		cn: 'Requests from programmatic buyers by status. The faster you will approve and transferred to the “Campaign" status, the more money you will earn.',
		pt: 'Solicitações de compradores programáticos por status. Quanto mais rápido você aprovar e transferir para o status “Campanha”, mais dinheiro você ganhará.'
	},
	campaigns_ssp_hint: {
		en: 'Campaigns of programmatic buyers by status. Campaigns are Requests that were previously approved by your SSP account.',
		ge: 'პროგრამული მყიდველების კამპანიები სტატუსის მიხედვით. კამპანიები არის მოთხოვნები, რომლებიც ადრე იყო დამტკიცებული თქვენი SSP ანგარიშის მიერ.',
		de: 'Kampagnen programmatischer Käufer nach Status. Kampagnen sind Anfragen, die zuvor von Ihrem SSP-Konto genehmigt wurden.',
		ru: 'Кампании покупателей программатик рекламы с делением по статусам. Кампании - это Заявки ранее одобренные вашим аккаунтом SSP.',
		cn: 'Campaigns of programmatic buyers by status. Campaigns are Requests that were previously approved by your SSP account.',
		pt: 'Campanhas de compradores programáticos por status. Campanhas são solicitações previamente aprovadas pela sua conta SSP.'
	},
	balance_dsp_hint: {
		en: 'The balance of your DSP account, which is spent on the purchase of advertising.',
		ge: 'თქვენი DSP ანგარიშის ბალანსი, რომელიც იხარჯება რეკლამის შესაძენად.',
		de: 'Der Saldo Ihres DSP-Kontos, der für den Kauf von Werbung verwendet wird.',
		ru: 'Баланс вашего DSP аккаунта доступный для покупки рекламы.',
		cn: 'The balance of your DSP account, which is spent on the purchase of advertising.',
		pt: 'O saldo da sua conta DSP, que é usado para a compra de publicidade.'
	},
	requests_dsp_hint: {
		en: 'Your requests for placement of Ad Campaigns.',
		ge: 'თქვენი მოთხოვნები სარეკლამო კამპანიების განთავსების შესახებ.',
		de: 'Ihre Anfragen zur Platzierung von Werbekampagnen.',
		ru: 'Ваши заявки на размещение Кампаний рекламы с делением по статусам.',
		cn: 'Your requests for placement of Ad Campaigns.',
		pt: 'Suas solicitações para a veiculação de campanhas publicitárias.'
	},
	campaigns_dsp_hint: {
		en: 'Your Campaigns are divided by status. Campaigns are Requests previously approved by the SSP administrator.',
		ge: 'თქვენი კამპანიები იყოფა სტატუსის მიხედვით. კამპანიები არის მოთხოვნები, რომლებიც ადრე იყო დამტკიცებული თქვენი SSP ანგარიშის მიერ.',
		de: 'Ihre Kampagnen sind nach Status unterteilt. Kampagnen sind Anfragen, die zuvor vom SSP-Administrator genehmigt wurden.',
		ru: 'Ваши Кампании с делением по статусам. Кампании - это Заявки ранее одобренные администратором сети.',
		cn: 'Your Campaigns are divided by status. Campaigns are Requests previously approved by the SSP administrator.',
		pt: 'Suas campanhas são divididas por status. Campanhas são solicitações previamente aprovadas pelo administrador do SSP.'
	},
	empty_balance: {
		en: 'Contact admin to add money to your balance.',
		ge: 'დაუკავშირდით ადმინისტრატორს ბალანსზე ფულის დასამატებლად.',
		de: 'Kontaktieren Sie den Administrator, um Geld auf Ihr Guthaben zu laden.',
		ru: 'Свяжитесь с администратором, чтобы пополнить баланс',
		cn: 'Contact admin to add money to your balance.',
		pt: 'Contate o administrador para adicionar dinheiro ao seu saldo.'
	},
	empty_balance_hint: {
		en: 'To start Campaigns, you need to have money on your balance. To top up your account, you need to contact the administrator who has given you access to the platform.',
		ge: 'კამპანიების დასაწყებად, ბალანსზე უნდა გქონდეთ ფული. თქვენი ანგარიშის შესავსებად, თქვენ უნდა დაუკავშირდეთ ადმინისტრატორს, რომელმაც მოგცათ პლატფორმაზე წვდომა.',
		de: 'Um Kampagnen zu starten, müssen Sie Geld auf Ihrem Konto haben. Um Ihr Konto aufzuladen, müssen Sie den Administrator kontaktieren, der Ihnen Zugang zur Plattform gewährt hat.',
		ru: 'Для старта Кампаний необходимо иметь средства на счету. Для пополнения баланса необходимо связаться с администратором, который предоставил вам доступ в платформу.',
		cn: 'To start Campaigns, you need to have money on your balance. To top up your account, you need to contact the administrator who has given you access to the platform.',
		pt: 'Para iniciar campanhas, você precisa ter saldo. Para recarregar sua conta, contate o administrador que lhe concedeu acesso à plataforma.'
	},
	for_day: {
		en: 'For a day',
		ge: 'ერთი დღით',
		de: 'Für einen Tag',
		ru: 'За сутки',
		cn: 'For a day',
		pt: 'Por um dia'
	},
	for_week: {
		en: 'For a week',
		ge: 'ერთი კვირის განმავლობაში',
		de: 'Für eine Woche',
		ru: 'За неделю',
		cn: 'For a week',
		pt: 'Por uma semana'
	},
	save: {
		en: 'Save',
		ge: 'შენახვა',
		de: 'Speichern',
		ru: 'Сохранить',
		cn: 'Save',
		pt: 'Salvar'
	},
	week_changes: {
		en: 'Compared to the previous week, this indicator changed by ',
		ge: 'წინა კვირასთან შედარებით, ეს მაჩვენებელი შეიცვალა',
		de: 'Im Vergleich zur Vorwoche hat sich dieser Indikator um ',
		ru: 'По сравнению с предыдущей неделей этот показатель изменился на ',
		cn: 'Compared to the previous week, this indicator changed by ',
		pt: 'Em comparação com a semana anterior, este indicador mudou em '
	},
	day_changes: {
		en: 'Compared to the previous day, this indicator has changed by ',
		ge: 'წინა დღესთან შედარებით, ეს მაჩვენებელი შეიცვალა  ',
		de: 'Im Vergleich zum Vortag hat sich dieser Indikator um ',
		ru: 'По сравнению с прошлыми сутками этот показатель изменился на ',
		cn: 'Compared to the previous day, this indicator has changed by ',
		pt: 'Em comparação com o dia anterior, este indicador mudou em '
	},
	download_inventory_list: {
		en: 'Inventory list',
		ge: 'ინვენტარის სია',
		de: 'Inventarliste',
		ru: 'Адресный план',
		cn: 'Inventory list',
		pt: 'lista de inventário'
	},
	by_who: {
		en: 'By',
		ge: 'გვერდზე',
		de: 'Von',
		ru: 'От',
		cn: 'By',
		pt: 'Por'
	},
	label: {
		en: 'Label',
		ge: 'ეტიკეტი',
		de: 'Label',
		ru: 'Лейбл',
		cn: 'Label',
		pt: 'rótulo'
	},
	good_uptime: {
		en: '<12h uptime',
		ge: '<12ს განამვლობაში',
		de: '<12h Betriebszeit',
		ru: '<12Ч время',
		cn: '<12h uptime',
		pt: 'uptime <12h'
	},
	average_uptime: {
		en: '>12h uptime',
		ge: '>12ს განამვლობაში',
		de: '>12h Betriebszeit',
		ru: '>12Ч время',
		cn: '>12h uptime',
		pt: 'uptime >12h'
	},
	bad_uptime: {
		en: '>48h',
		ge: '>48ს',
		de: '>48h',
		ru: '>48Ч',
		cn: '>48h',
		pt: '>48h'
	},
	uptime_hint: {
		en: 'The Uptime of devices is the time during which a request was made from a specific device to the server for the selection of ads for playback.\n\nLess than 12 hours is a great place to place ads with a large advertising capacity.\n\nMore than 12 hours are places with a small free capacity for advertising at a given time or places with a poor Internet connection.\n\nMore than 48 hours are places with the minimum free capacity for advertising at this time, possibly temporarily turned off devices or places with a poor Internet connection.',
		ge: 'მოწყობილობების მოქმედების დრო არის დრო, რომლის დროსაც მოხდა მოთხოვნა კონკრეტული მოწყობილობიდან სერვერზე რეკლამის ასარჩევად, დასაკრავად.\n\nLess than 12 hours is a great place to place ads with a large advertising capacity.\n\nMore than 12 hours are places with a small free capacity for advertising at a given time or places with a poor Internet connection.\n\nMore than 48 hours are places with the minimum free capacity for advertising at this time, possibly temporarily turned off devices or places with a poor Internet connection.',
		de: 'Die Betriebszeit von Geräten ist die Zeit, in der eine Anfrage von einem bestimmten Gerät an den Server zur Auswahl von Anzeigen für die Wiedergabe gestellt wurde.\n\nWeniger als 12 Stunden ist ein großartiger Ort, um Anzeigen mit einer großen Werbekapazität zu platzieren.\n\nMehr als 12 Stunden sind Orte mit einem geringen freien Werbevolumen zu diesem Zeitpunkt oder Orte mit einer schlechten Internetverbindung.\n\nMehr als 48 Stunden sind Orte mit der minimalen freien Kapazität für Werbung zu diesem Zeitpunkt, möglicherweise vorübergehend ausgeschaltete Geräte oder Orte mit einer schlechten Internetverbindung.',
		ru: 'Время безотказной работы устройств (Uptime) – это время, в течение которого с конкретного устройства поступает запрос к серверу для подбора рекламы для воспроизведения.\n\nМенее 12 часов – отличное место для размещения рекламы с большой ёмкостью.\n\nБолее 12 часов – это места с небольшой свободной ёмкостью для рекламы или с плохим интернет-соединением.\n\nБолее 48 часов – это места с минимальной свободной ёмкостью для рекламы, возможно, с временно выключенными устройствами или плохим соединением.',
		cn: 'The Uptime of devices is the time during which a request was made from a specific device to the server for the selection of ads for playback.\n\nLess than 12 hours is a great place to place ads with a large advertising capacity.\n\nMore than 12 hours are places with a small free capacity for advertising at a given time or places with a poor Internet connection.\n\nMore than 48 hours are places with the minimum free capacity for advertising at this time, possibly temporarily turned off devices or places with a poor Internet connection.',
		pt: 'O uptime dos dispositivos é o tempo durante o qual um dispositivo específico faz uma solicitação ao servidor para a seleção de anúncios para exibição.\n\nMenos de 12 horas é um ótimo período para veicular anúncios com alta capacidade publicitária.\n\nMais de 12 horas indicam locais com pouca capacidade gratuita para publicidade ou com conexão de internet precária.\n\nMais de 48 horas apontam para locais com a capacidade mínima para publicidade, possivelmente com dispositivos temporariamente desligados ou com conexão ruim.'
	},
	start_time: {
		en: 'start time',
		ge: 'დაწყების დრო',
		de: 'Startzeitpunkt',
		ru: 'время старта',
		cn: 'start time',
		pt: 'hora de início'
	},
	end_time: {
		en: 'end time',
		ge: 'დასრულების დრ',
		de: 'Endzeitpunkt',
		ru: 'время окончания',
		cn: 'end time',
		pt: 'hora de término'
	},
	approve_creatives_first_warning: {
		en: 'Please, approve creatives',
		ge: 'გთხოვთ, დაადასტურეთ შექმნა',
		de: 'Bitte genehmigen Sie die Werbemittel',
		ru: 'Пожалуйста, утвердите креативы',
		cn: 'Please, approve creatives',
		pt: 'Por favor, aprove os criativos'
	},
	approve_advertiser_first_warning: {
		en: 'Please, approve advertiser',
		ge: 'Please, approve advertiser',  // TODO: translate
		de: 'Please, approve advertiser',  // TODO: translate
		ru: 'Пожалуйста, утвердите рекламодателя',
		cn: 'Please, approve advertiser',  // TODO: translate
		pt: 'Please, approve advertiser',  // TODO: translate
	},
	advanced_settings_label: {
		en: 'Advanced Settings',
		ge: 'მოწინავე პარამეტრები',
		de: 'Erweiterte Einstellungen',
		ru: 'Расширенные настройки',
		cn: 'Advanced Settings',
		pt: 'Configurações avançadas'
	},
	date: {
		en: 'Date',
		ge: 'თარიღი',
		de: 'Datum',
		ru: 'Дата',
		cn: 'Date',
		pt: 'Data'
	},
	login: {
		en: 'Login',
		ge: 'შესვლა',
		de: 'Anmelden',
		ru: 'Логин',
		cn: '登录',
		pt: 'Entrar'
	},
	old_value: {
		en: 'Old value',
		ge: 'Old value',
		de: 'Old value',
		ru: 'Cтарое значение',
		cn: 'Old value',
		pt: 'Valor antigo'
	},
	new_value: {
		en: 'New value',
		ge: 'New value',
		de: 'New value',
		ru: 'Новое значение',
		cn: 'New value',
		pt: 'Novo valor'
	},
	history_error: {
		en: 'Error getting history',
		ge: 'Error getting history',
		de: 'Error getting history',
		ru: 'Ошибка при получении истории',
		cn: 'Error getting history',
		pt: 'Erro ao obter histórico'
	},
	history_not_found: {
		en: 'No change history',
		ge: 'No change history',
		de: 'No change history',
		ru: 'История изменений отсутствует',
		cn: 'No change history',
		pt: 'Sem histórico de alterações'
	},
	changes_in_creative: {
		en: 'Changes in creative',
		ge: 'Changes in creative',
		de: 'Changes in creative',
		ru: 'Изменения в креативе',
		cn: 'Changes in creative',
		pt: 'Alterações no criativo'
	},
	old_device_list_count: {
		en: 'There were devices',
		ge: 'There were devices',
		de: 'There were devices',
		ru: 'Было устройств',
		cn: 'There were devices',
		pt: 'Havia dispositivos'
	},
	new_device_list_count: {
		en: 'Became devices',
		ge: 'Became devices',
		de: 'Became devices',
		ru: 'Стало устройств',
		cn: 'Became devices',
		pt: 'Tornaram-se dispositivos'
	},
	status: {
		en: 'status',
		ge: 'status',
		de: 'status',
		ru: 'cтатус',
		cn: 'status',
		pt: 'status'
	},
	last_message: {
		en: 'last message',
		ge: 'last message',
		de: 'last message',
		ru: 'последнее сообщение',
		cn: 'last message',
		pt: 'última mensagem'
	},
	action_add: {
		en: 'added',
		ge: 'added',
		de: 'added',
		ru: 'добавлен',
		cn: 'added',
		pt: 'adicionado'
	},
	action_remove: {
		en: 'removed',
		ge: 'removed',
		de: 'removed',
		ru: 'удален',
		cn: 'removed',
		pt: 'removido'
	},
	multi_spp_info_message: {
		en: 'To select several advertising platforms, you need to make different request',
		ge: 'To select several advertising platforms, you need to make different request',
		de: 'To select several advertising platforms, you need to make different request',
		ru: 'Для выбора нескольких площадок размещения рекламы требуется сделать разные заявки',
		cn: 'To select several advertising platforms, you need to make different request',
		pt: 'Para selecionar várias plataformas publicitárias, você precisa fazer solicitações diferentes'
	},
	lifetime_budget: {
		en: 'Lifetime budget',
		ge: 'Lifetime budget', // TODO: translation needed
		de: 'Lifetime budget', // TODO: translation needed
		ru: 'Lifetime budget', // TODO: translation needed
		cn: 'Lifetime budget', // TODO: translation needed
		pt: 'Lifetime budget' // TODO: translation needed
	},
};
